/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

// import redux

import {
  resetEditBankBeneficiary,
  resetEditBeneficiary,
} from "../../../../redux/features/accounts/BeneficiaryAccount/createAccount";

import {
  beneBankLookUp,
  beneVerifyThisPAN,
} from "../../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";

import { resetServices } from "../../../../redux/features/refreshToken/refreshToken";
import { requestTxnReject } from "../../../../redux/features/reimbursementRequest/index.js";
import { ReimbursementTxnDeniedApproval } from "../../../../redux/features/reimbursementTransaction/index.js";
import {
  beneLookUp,
  resetInEdit,
} from "../../../../redux/features/verifyPAN/verifyPAN";

// import components

import TEXT from "../../../../../src/utils/globalText";
import ICONS from "../../../../assets/Icons";
import AdditionalRecipient from "../../../../components/AdditionalRecipient";
import FullScreen from "../../../../components/FullScreen";
import Loader from "../../../../components/Loader/Index";
import ReimbursementTxnViewAllPopup from "../../../../components/ReimbursementTxnViewAllPopup/index.jsx";
import useServiceChecker from "../../../../components/ServiceChecker";
import UserDetailsPopup from "../../../../components/Settings/User/UserDetailsPopup/index.jsx";
import CommonAlertsStrip from "../../../../components/_utils/CommonAlertsStrip/index.jsx";
import CommonBankLogo from "../../../../components/_utils/CommonBankLogo";
import SwitcherTabs from "../../../../components/_utils/CommonButtons/SwitcherTabs";
import TopNavLargeButton from "../../../../components/_utils/CommonButtons/TopNavLargeButton";
import TopNavSmallButton from "../../../../components/_utils/CommonButtons/TopNavSmallButton";
import CommonContainerCard from "../../../../components/_utils/CommonContainerCard";
import CommonDetailCard from "../../../../components/_utils/CommonDetailCard";
import CommonAssignLabelPopup from "../../../../components/_utils/CommonPopups/CommonAssignLabelPopup/index.jsx";
import EditCommonPopup from "../../../../components/_utils/CommonPopups/CommonEditPopup";
import LargePopupRedirect from "../../../../components/_utils/CommonPopups/CommonLargePopupRedirect";
import SmallPopup from "../../../../components/_utils/CommonSmallPopup";
import SmallPopupWithInput from "../../../../components/_utils/CommonSmallPopupWithInput";
import CommonToast from "../../../../components/_utils/CommonToast";
import { formatAccountNumber } from "../../../../components/_utils/FormatAccountNumber";
import TickerAnimation from "../../../../components/_utils/TickerAnimation";
import TitleSubtitlePair from "../../../../components/_utils/TitleSubtitlePair";
import UniversalRefreshToast from "../../../../components/_utils/UniversalRefreshToast";
import OwnerAccountIFSC from "../../../../containers/Accounts/OwnerAccount/OwnerAccountIFSC";
import GSTVerification from "../../../../containers/Settings/GSTDetails";
import PanVerification from "../../../../containers/Settings/PanVerification";
import accountNameStandardised from "../../../../utils/accountNamestandardised.js";
import {
  GlobalConfiguration,
  IntervalConfiguration,
  RejectReasonLength,
  ScreenSizeConfiguration,
  TimelineConfiguration,
} from "../../../../utils/configurationProvider";
import formatDateViewAll from "../../../../utils/formatDateViewAll";
import { linkIdentifier } from "../../../../utils/linkIdentifier";
import useCategories from "../../../../utils/useCategories";
import ReimbursementRequestViewAll from "../../../ReimbursementRequest/ReimbursementRequestViewAll/index.jsx";
import ReimbursementTransactionsViewAll from "../../../Transactions/ReimbursementTransactions/ReimbursementTransactionViewAll";
import ReimbursementAccountViewAll from "../AccountViewAll";

import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent/index.jsx";
import {
  achivedAccountDetail,
  addNewLabel,
  editReimbursementAccount,
  ReimburseApproveAccount,
  ReimburseRejectAccount,
  removeNewLabel,
  resetToggle,
  setDetailDataToApprovalData,
  setDetailDataToRejectData,
  unachivedAccountDetail,
  viewAccountDetail,
} from "../../../../redux/features/accounts/ReimburseAccount/index.js";

const ReimbursementAccountDetails = (props) => {
  const labelActionDispatchedRef = useRef(false);
  const [ensureAll] = useServiceChecker();
  const categoryMapper = useCategories();
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const dispatch = useDispatch();
  let label;
  const pathName = location?.state?.from ? location?.state?.from : "";
  const txn_single_appr = location?.state?.type ? location?.state?.type : "";

  const { viewAccountDetailData, ReimburseRejectData } = useSelector(
    (state) => state.ReimburseAccount,
  );

  const {
    reimbursementRequestViewAllData,
    reimbursementRequestViewAllLoading,
  } = useSelector((state) => state.reimbursementRequest);

  const services = useSelector((state) => state.refreshToken.services);

  const sliceCategory = useSelector(
    (state) => state.beneAllVerification.beneTransCategories.categories,
  );

  const { reimbursementTxnViewAllLoading, reimbursementTxnViewAllData } =
    useSelector((state) => state?.reimbursementTransaction);

  //useState
  const [archiveloader, setArchiveLoader] = useState(false);
  const [isMobile, setIsMobile] = useState(
    window.innerWidth <= ScreenSizeConfiguration?.mobileScreen,
  );
  const [selectedChipIndex, setSelectedChipIndex] = useState(null);
  const [HistoryPopup, setHistoryPopup] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [searchPanText, setSearchPanText] = useState("");
  const [activeType, setActiveType] = useState("pan");
  const [showPopupReject, setshowPopupReject] = useState(false);
  const [ArchiveType, setArchiveType] = useState("");
  const [userpopup, setUserpopup] = useState(false);
  const [RequestRejectAll, setRequestRejectAll] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [unachivedOpenPop, setUnachivedOpenPop] = useState(false);
  const [achivedOpenPop, setAchivedOpenPop] = useState(false);
  const [ViewAccountDetails, SetViewAccountDetails] = useState([]);
  const [showGstPopup, setGstShowPopup] = useState(false);
  const [showPanPopup, setPanShowPopup] = useState(false);
  const [showIfscPopup, setIfscShowPopup] = useState(false);
  const [deniedId, SetdeniedId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [nameArchive, setNameArchive] = useState("");
  const [alertPopUp, setAlertPopUp] = useState(false);
  const [currentAccountDetails, setCurrentAccountDetails] = useState({
    name: "",
    bank_name: "",
    ifsc_code: "",
    bank_acc_no: "",
    category: "",
    id: "",
    pan: "",
    bank_account_holder_full_name: "",
  });
  const [remPan, setRemPan] = useState("");
  const [remAccount, setRemAccount] = useState("");
  const [remIFSC, setIFSC] = useState("");
  const [openBeneAssociate, setOpenBeneAssociate] = useState(false);
  const [showRejectTnxPopup, setRejectTxnPopup] = useState(false); // show reject reimbursement txn popup
  const [showLabelsPopup, setShowLabelsPopup] = useState(false);
  const [labels, setLabels] = useState([]);
  const [labelDetails, setLabelDetails] = useState([]);
  const [showAdditionalRecipient, setShowAdditionalRecipient] = useState([]);
  const [TxnHistoryid, setTxnHistoryid] = useState("");
  const [TxnHistoryAccountName, setTxnHistoryAccountName] = useState("");
  const [showAdditionalSection, setShowAdditionalSection] = useState(false);
  const [recipients, setRecipients] = useState([]);
  const [recipientButtonDisabled, setRecipientButtonDisabled] = useState(true);
  const [additionalChip, setAdditionalChip] = useState(showAdditionalRecipient);
  const [declineReason, setDeclineReason] = useState("");
  const [associateType, setAssociateType] = useState("");
  const [category, setCategory] = useState("");
  const [bankDetails, setBankDetails] = useState({
    name: "",
    bankAccountNumber: "",
    ifscCode: "",
  });
  const [seachType, setSearchtype] = useState("");
  const [previousContactDetails, setPreviousContactDetails] = useState({
    legalName: "",
    contact: "",
    email: "",
    gstin: "",
    category: null,
  });
  const [index, setIndex] = useState(GlobalConfiguration?.lengthCheckZero);
  const [prevIndex, setPrevIndex] = useState(
    GlobalConfiguration?.lengthCheckZero,
  );
  const [animationClass, setAnimationClass] = useState("");

  //function

  const handleInputChange = (event) => {
    const value = event.target.value;

    const sanitizedValue = value.replace(/[^a-zA-Z0-9\s]/g, "");

    const limitedValue = sanitizedValue.slice(
      GlobalConfiguration.lengthCheckZero,
      RejectReasonLength.lengthOfDecline,
    );

    setDeclineReason(limitedValue);
  };

  function handleChipClick(id) {
    setSelectedChipIndex(id);
  }

  const chipsArray = [
    {
      text: "IFSC Code",
      selected: selectedChipIndex === GlobalConfiguration.lengthCheckZero,
      disabled: false,
      hoverOption: "white",
      bulletPoint: [
        "Please contact an Xpentra administrator to change the IFSC detail.",
      ],
      onClick: () => handleChipClick(GlobalConfiguration.lengthCheckZero),
    },
    {
      text: "Name, Contact details, User, Email ID",
      selected: selectedChipIndex === GlobalConfiguration.lengthCheckOne,
      disabled: false,
      bulletPoint: ["Require approval."],
      hoverOption: "white",
      onClick: () => handleChipClick(GlobalConfiguration.lengthCheckOne),
    },
    {
      text: "Categories",
      selected: selectedChipIndex === TimelineConfiguration.barWidthMedium,
      disabled: false,
      onClick: () => handleChipClick(GlobalConfiguration?.lengthCheckTwo),
      bulletPoint: ["Require approval."],
      hoverOption: "white",
    },
    {
      text: "PAN number, GST",
      selected: selectedChipIndex === TimelineConfiguration.barWidthLarge,
      disabled: false,
      bulletPoint: ["Require approval."],
      onClick: () => handleChipClick(GlobalConfiguration?.lengthCheckThree),
      hoverOption: "white",
    },
    {
      text: "Bank account number",
      selected: selectedChipIndex === GlobalConfiguration?.lengthCheckFour,
      disabled: false,
      bulletPoint: [
        "Require approval.",
        "Creates a new beneficiary account.",
        "Archives the old account.",
      ],
      onClick: () => handleChipClick(GlobalConfiguration?.lengthCheckFour),
      hoverOption: "white",
    },
  ];

  const handleConfirmDecline = async (id, AccountIdData) => {
    setShowLoader(true);

    UniversalRefreshToast("accountsRefresh");

    const data = await dispatch(ReimburseRejectAccount({ id, AccountIdData }));
    if (
      data?.payload?.errors?.user_unauthorized?.length >
      GlobalConfiguration?.lengthCheckZero
    ) {
      navigate("/feature_not_assigned", {
        state: {
          unavailableService: "CReimbursementTxn",
        },
      });
      return;
    }

    setShowLoader(true);

    await new Promise((resolve) => {
      setTimeout(resolve, IntervalConfiguration.intervalExtraLarge);
    });

    if (data?.payload?.status === false || data?.payload === undefined) {
      let error_msg = "";
      let error_list = null;
      if (data?.payload === undefined) {
        error_msg = "An error occured while taking action on this account";
      } else if (data?.payload?.errors?.reimbursement_account) {
        if (
          data?.payload?.errors?.reimbursement_account?.length >
          GlobalConfiguration?.lengthCheckOne
        ) {
          error_list = data?.payload?.errors?.reimbursement_account;
          error_msg = data?.payload?.errors?.reimbursement_account[0];
        } else {
          error_msg = data?.payload?.errors?.reimbursement_account;
          CommonToast({
            text: error_msg[0],
            icon: ICONS?.ERROR_WHITE_CIRCLE,
            variant: "var(--error)",
            btnProps: {
              isDisabled: false,
              enabledTextColor: "var(--text_primary)",
              enabledBgColor: "var(--primary_bg)",
            },
          });
        }
      } else if (data?.payload?.errors?.reimbursement_account) {
        error_msg = data?.payload?.errors?.reimbursement_account[0];
      } else if (data?.payload?.status === false) {
        error_msg = data?.payload?.errors?.category?.[0];
      } else if (data?.payload?.errors?.bank_account_number?.[0]) {
        error_msg = data?.payload?.errors?.bank_account_number[0];
      }

      if (error_msg === "Reimbursement account already rejected") {
        const newData = await dispatch(
          viewAccountDetail({ id: props?.bene_account_id || id }),
        );
        const updatedBeneficiaryAccount = {
          ...newData?.payload?.reimbursement_accounts?.[0],
          error_msg,
          error: data?.payload?.status === false ? true : false,
        };

        const updatedData = ViewAccountDetails?.map((item) => {
          if (item.id === id) {
            return {
              ...item,
              ...(updatedBeneficiaryAccount || {}),
            };
          }
          return item;
        });
        updateAllAccounts(updatedData);
      } else {
        const updatedData = ViewAccountDetails?.map((item) => {
          if (item.id === id) {
            return {
              ...item,
              error_msg,
              error: data?.payload?.status === false ? true : false,
            };
          }
          return item;
        });
        updateAllAccounts(updatedData);
      }
      setShowLoader(false);
      setDeclineReason("");
      handleClosePopup();
      if (
        Array.isArray(error_list) &&
        error_list.length > GlobalConfiguration?.lengthCheckOne
      ) {
        error_list.forEach((err) => {
          setTimeout(() => {
            CommonToast({
              text: err,
              icon: ICONS?.ERROR_WHITE_CIRCLE,
              variant: "var(--error)",
              btnProps: {
                isDisabled: false,
                enabledTextColor: "var(--text_primary)",
                enabledBgColor: "var(--primary_bg)",
              },
            });
          }, IntervalConfiguration?.intervalSmall);
        });
      } else {
        CommonToast({
          text: error_msg,
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text_primary)",
            enabledBgColor: "var(--primary_bg)",
          },
        });
      }
    } else {
      const updatedData = ViewAccountDetails?.map((item) => {
        if (item.id === id) {
          return {
            ...item,
            approval_status:
              item.approval_status === "pending" ? "rejected" : "pending",

            rejected_on:
              data?.payload?.status === true
                ? data?.payload?.reimbursement_accounts[0]?.rejected_on
                : "",
            rejected_by_name:
              data?.payload?.status === true
                ? data?.payload?.reimbursement_accounts[0]?.rejected_by_name
                : "",
            rejection_reason: AccountIdData,
            error:
              item.error === false && data?.payload?.status === false
                ? true
                : false,
            message:
              item.message === "" && data?.payload?.status === false
                ? data?.payload?.errors?.reimbursement_account[0]
                : "",
          };
        }
        return item;
      });
      updateAllAccounts(updatedData);
      setShowLoader(false);
      setDeclineReason("");
      handleClosePopup();

      CommonToast({
        text: "Account rejected successfully.",
        icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });

      if (pathName) {
        setTimeout(() => {
          navigate(pathName);
        }, IntervalConfiguration.intervalExtraLarge);
      }
      if (props?.type === "reimburseacc_details") {
        setTimeout(() => {
          props?.closeBeneAccountDetailModal();
          window.location.reload();
        }, IntervalConfiguration.intervalExtraSmall);
      }
      dispatch(setDetailDataToRejectData());
    }
  };

  const handleApply = () => {
    dispatch(resetServices());

    dispatch(resetEditBeneficiary());
    dispatch(resetEditBankBeneficiary());

    switch (selectedChipIndex) {
      case 0: // IFSC Code
        break;
      //
      case 1: // Account name, Contact number, Email
        navigate(
          `/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/Edit_contact/${id}`,
          {
            state: previousContactDetails,
          },
        );
        break;

      case 2: // Assigned categories
        navigate(
          `/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/edit_category/${id}`,
          {
            state: previousContactDetails,
          },
        );
        break;

      case 3: // PAN Number, GST
        dispatch(resetInEdit());
        navigate(
          `/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/PAN_details/${id}`,
        );
        break;

      case 4:
        // Bank account number
        navigate(
          `/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/bank_details/${id}`,
          {
            state: bankDetails,
          },
        );
        dispatch(resetEditBankBeneficiary());
        break;

      default:
        break;
    }
  };

  async function fetchData() {
    setLoading(true);
    try {
      let response;
      if (props?.type === "reimburseacc_details") {
        response = await dispatch(
          viewAccountDetail({ id: props?.bene_account_id }),
        );
      } else {
        response = await dispatch(
          viewAccountDetail({ id: props?.bene_account_id || id }),
        );
      }

      setLabelDetails(
        response?.payload?.reimbursement_accounts?.[0]?.labels || [],
      );
      setShowAdditionalRecipient(
        response?.payload?.reimbursement_accounts?.[0]?.recipient_email || [],
      );
      setAdditionalChip(
        response?.payload?.reimbursement_accounts?.[0]?.recipient_email || [],
      );

      if (response?.error?.message === "Request failed with status code 404") {
        navigate("/*");
      }
      // setIndex(GlobalConfiguration.lengthCheckZero);
    } catch (error) {
      error("Failed to load the account details", error);
    } finally {
      setLoading(false);
    }
  }
  const finalRecipients = [...new Set([...recipients, ...additionalChip])];

  const handleConfirm = async () => {
    if (recipientButtonDisabled) return;
    const recipientString = [...recipients, ...additionalChip].join(",");
    let response = await dispatch(
      editReimbursementAccount({ id: id, recipient_email: recipientString }),
    );
    if (response?.payload?.status) {
      setShowAdditionalSection(false);
      await fetchData();
      setRecipients([]);
    } else {
      setShowAdditionalSection(false);
    }
  };

  const handleClose = () => {
    if (labelActionDispatchedRef.current) {
      labelActionDispatchedRef.current = false;
    }
    setShowLabelsPopup(false);
  };
  const handleModalClose = () => {
    setIsEditModalOpen(false);
    setSelectedChipIndex(null);
  };

  const handlePANDetails = async (pan) => {
    if (pan?.length === GlobalConfiguration?.panLength) {
      const response = await dispatch(
        beneVerifyThisPAN({ search_string: pan }),
      );
      if (response?.payload?.status === true) {
        setPanShowPopup(true);
      } else if (response?.payload?.errors?.user_unauthorized?.[0]) {
        navigate("/feature_not_assigned", {
          state: {
            unavailableService: "RUAccount",
          },
        });
      } else if (response?.payload?.status === false) {
        CommonToast({
          text: response?.payload?.errors?.base[0],
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text_primary)",
            enabledBgColor: "var(--primary_bg)",
          },
        });
      }
    }
  };

  const isArchived =
    viewAccountDetailData?.reimbursement_accounts?.[0]?.approval_status ===
    "archived";

  if (
    services?.find(
      (service) => service === "RAAccountArchive" || service === "Admin",
    ) === undefined &&
    viewAccountDetailData?.reimbursement_accounts?.[0]?.approval_status ===
      "archived"
  ) {
    label = (
      <>
        Unarchive <br /> account{" "}
      </>
    );
  } else {
    label = (
      <>
        Archive <br /> account{" "}
      </>
    );
  }

  const handleCloseModal = () => {
    setArchiveLoader(false);
    setUnachivedOpenPop(false);
    setAchivedOpenPop(false);
    setOpenBeneAssociate(false);
  };

  const actionRestricted = () => {
    CommonToast({
      text: "Action restricted in popup mode.",
      icon: ICONS?.ERROR_WHITE_CIRCLE,
      variant: "var(--error)",
    });
  };

  const handleUnarchive = () => {
    setUnachivedOpenPop(true);
    if (viewAccountDetailData?.reimbursement_accounts?.[0]?.archived === "N") {
      setUnachivedOpenPop(false);
    } else {
      setUnachivedOpenPop(true);
    }
  };
  const handleArchive = () => {
    if (viewAccountDetailData?.reimbursement_accounts?.[0]?.archived === "N") {
      setAchivedOpenPop(true);
    } else {
      setAchivedOpenPop(false);
    }
  };

  const toggleCategories = () => {
    setIndex(GlobalConfiguration.lengthCheckOne);
  };

  const handleRejectTransactionChecker = async (id, AccountIdData) => {
    setshowPopupReject(false);

    // const accountInfo = await dispatch(viewAccountDetail({ id: deniedId }));

    if (
      viewAccountDetailData?.reimbursement_accounts?.[0]
        ?.pending_reimbursement_transactions === "Y"
    ) {
      setRejectTxnPopup(true);
    } else if (
      viewAccountDetailData?.reimbursement_accounts?.[0]
        ?.pending_reimbursement_requests === "Y"
    ) {
      setRequestRejectAll(true);
    } else {
      handleConfirmDecline(id ? id : props?.bene_account_id, AccountIdData);
    }
  };

  const openAssociatedAccountsFound = () => {
    dispatch(beneLookUp({ pan_number: currentAccountDetails.pan }));
    setRemPan(currentAccountDetails.pan);
    dispatch(
      beneBankLookUp({
        ifsc: currentAccountDetails.ifsc_code,
        bank_account_no: currentAccountDetails.bank_acc_no,
        bank_account_holder_full_name:
          currentAccountDetails.bank_account_holder_full_name,
      }),
    );

    setOpenBeneAssociate(true);
  };

  const handleApprovalDetails = async (id) => {
    let response;
    UniversalRefreshToast("approvalaccountsRefresh");

    if (props?.type === "reimburseacc_details") {
      response = await dispatch(
        ReimburseApproveAccount(props?.bene_account_id),
      );
    } else {
      response = await dispatch(ReimburseApproveAccount(id));
    }

    if (
      response?.payload?.errors?.user_unauthorized?.length >
      GlobalConfiguration?.lengthCheckZero
    ) {
      navigate("/feature_not_assigned", {
        state: {
          unavailableService: "RAAccount",
        },
      });
      return;
    }
    if (
      response?.payload?.status === false ||
      response?.payload === undefined
    ) {
      let error_msg = "";
      if (response?.payload === undefined) {
        error_msg = "An error occured while taking action on this account";
      } else if (response?.payload?.errors?.reimbursement_account?.[0]) {
        error_msg = response.payload.errors.reimbursement_account[0];
      } else if (response?.payload?.errors?.bank_account_number?.[0]) {
        error_msg = response.payload.errors.bank_account_number[0];
      } else {
        error_msg = "An unknown error occurred.";
      }
      if (error_msg === "Reimbursement account already approved") {
        const updatedData = viewAccountDetailData?.reimbursement_accounts.map(
          (item) => {
            if (
              item.id === (props?.type === "reimburseacc_details")
                ? props?.bene_account_id
                : id
            ) {
              return {
                ...item,
                approval_status:
                  item.approval_status === "pending" ? "approved" : "pending",
              };
            }
            return item;
          },
        );
        SetViewAccountDetails(updatedData);

        response = await dispatch(
          viewAccountDetail({ id: props?.bene_account_id || id }),
        );
      } else {
        const updatedData = viewAccountDetailData?.reimbursement_accounts.map(
          (item) => {
            if (
              item.id === (props?.type === "reimburseacc_details")
                ? props?.bene_account_id
                : id
            ) {
              return {
                ...item,
                approval_status:
                  item.approval_status === "pending" ? "pending" : "",
                error_msg,
              };
            }
            return item;
          },
        );

        SetViewAccountDetails(updatedData);
      }
      CommonToast({
        text: error_msg,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text_primary)",
          enabledBgColor: "var(--primary_bg)",
        },
      });
    } else {
      const updatedData = viewAccountDetailData?.reimbursement_accounts.map(
        (item) => {
          if (
            item.id === (props?.type === "reimburseacc_details")
              ? props?.bene_account_id
              : id
          ) {
            return {
              ...item,
              approval_status:
                item.approval_status === "pending" ? "approved" : "pending",
            };
          }
          return item;
        },
      );
      SetViewAccountDetails(updatedData);

      response = dispatch(setDetailDataToApprovalData());
      const successMessage = "Account approved successfully.";

      CommonToast({
        text: successMessage,
        icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      if (props?.type === "reimburseacc_details") {
        setTimeout(() => {
          props?.closeBeneAccountDetailModal();
          window.location.reload();
        }, IntervalConfiguration.intervalExtraSmall);
      }

      if (txn_single_appr === "txn_single_approval") {
        setTimeout(() => {
          navigate(-1);
        }, IntervalConfiguration.intervalExtraLarge);
      }
    }
  };

  const handleDeclinedDetials = (id) => {
    setshowPopupReject(true);
    SetdeniedId(id);
  };

  const handleClosePopup = () => {
    setshowPopupReject(false);
    setDeclineReason("");
  };
  const updateAllAccounts = (updatedAccounts) => {
    SetViewAccountDetails(updatedAccounts);
  };

  const handleArchiveButton = async (id) => {
    setArchiveLoader(true);
    const accountInfo = viewAccountDetailData;

    if (
      accountInfo?.reimbursement_accounts?.[0]
        ?.pending_reimbursement_transactions === "Y"
    ) {
      setAchivedOpenPop(false);
      setArchiveLoader(false);
      setRejectTxnPopup(true);
    } else if (
      accountInfo?.reimbursement_accounts?.[0]
        ?.pending_reimbursement_requests === "Y"
    ) {
      setArchiveType("Requestarchive");
      setAchivedOpenPop(false);
      setArchiveLoader(false);
      setRequestRejectAll(true);
    } else {
      let thunkAction = achivedAccountDetail;

      UniversalRefreshToast("archive");
      const archived_response = await dispatch(thunkAction({ id, navigate }));
      if (
        archived_response.type !== "achivedAccountDetail/rejected" ||
        archived_response.payload === "Beneficiary account already archived"
      ) {
        // await dispatch(viewAccountDetail({ id }));
        await dispatch(viewAccountDetail({ id: props?.bene_account_id || id }));
      }
      handleCloseModal();
      setAchivedOpenPop(false);
    }
  };

  const archiveAccount = async (id) => {
    let thunkAction = achivedAccountDetail;

    UniversalRefreshToast("archive");
    const archived_response = await dispatch(thunkAction({ id, navigate }));
    if (
      archived_response.type !== "achivedAccountDetail/rejected" ||
      archived_response.payload === "Beneficiary account already archived"
    ) {
      await dispatch(viewAccountDetail({ id: props?.bene_account_id || id }));
    }
    handleCloseModal();
    setAchivedOpenPop(false);
    setArchiveLoader(false);
  };

  const handleUnArchiveButton = async () => {
    let thunkAction = unachivedAccountDetail;

    UniversalRefreshToast("unarchive");
    const unarchived_response = await dispatch(thunkAction({ id, navigate }));
    if (
      unarchived_response.type !== "unachivedAccountDetail/rejected" ||
      unarchived_response.payload === "Beneficiary account already pending"
    ) {
      await dispatch(viewAccountDetail({ id: props?.bene_account_id || id }));
    }
    handleCloseModal();
  };

  const handleModalOpen = (id) => {
    setIsEditModalOpen(id);
  };

  const handleArchiveRejectReimbursementTxn = async () => {
    setShowLoader(true);
    setshowPopupReject(false);
    const AccountIdData = declineReason;
    let id2 = [];

    id2 =
      !reimbursementTxnViewAllLoading &&
      reimbursementTxnViewAllData?.transactions?.length >
        GlobalConfiguration.lengthCheckZero
        ? reimbursementTxnViewAllData?.transactions.map((data) => data?.txn_id)
        : [];

    UniversalRefreshToast("Rejecting transaction");

    let data = null;

    if (id2.length > GlobalConfiguration.lengthCheckZero) {
      data = await dispatch(
        ReimbursementTxnDeniedApproval({ id: id2, AccountIdData }),
      );
    }

    if (
      data?.payload?.errors?.user_unauthorized?.length >
      GlobalConfiguration.lengthCheckZero
    ) {
      const serviceKey = "AReimbursementTxn";

      navigate("/feature_not_assigned", {
        state: { unavailableService: serviceKey },
      });
      return;
    }

    await new Promise((resolve) =>
      setTimeout(resolve, IntervalConfiguration.intervalExtraLarge),
    );

    if (data?.payload?.status === false) {
      const error_msg = data?.payload?.errors?.user_unauthorized
        ? data?.payload?.errors?.user_unauthorized[0]
        : Array.isArray(data?.payload?.errors?.base) &&
            Array.isArray(data?.payload?.errors?.base[0]?.errors)
          ? data.payload.errors.base[0].errors[0]
          : data?.payload?.errors?.base?.[0] || "Unknown error occurred";
      CommonToast({
        text: error_msg,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text_primary)",
          enabledBgColor: "var(--primary_bg)",
        },
      });

      setShowLoader(false);
    } else if (data?.payload?.status === true) {
      setRejectTxnPopup(false);
      setTimeout(() => {
        CommonToast({
          text: "Transaction rejected successfully.",
          icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }, IntervalConfiguration?.intervalSmall);

      if (
        viewAccountDetailData?.reimbursement_accounts[0]
          ?.pending_reimbursement_requests === "Y"
      ) {
        setArchiveType("Requestarchive");
        setRequestRejectAll(true);
      } else {
        archiveAccount(id);
      }
    } else if (data?.payload === undefined) {
      CommonToast({
        text: "An error occurred while taking action on this account",
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text_primary)",
          enabledBgColor: "var(--primary_bg)",
        },
      });
    }
    setTimeout(() => {
      setRejectTxnPopup(false);
    }, IntervalConfiguration.intervalMedium);
    if (associateType !== "rejectAccount") {
      setAssociateType("");
    }
    setShowLoader(false);
  };

  const handleRejectReimbursementTxn = async () => {
    setShowLoader(true);
    setshowPopupReject(false);
    const AccountIdData = declineReason;
    let id2 = [];

    id2 =
      !reimbursementTxnViewAllLoading &&
      reimbursementTxnViewAllData?.transactions?.length >
        GlobalConfiguration.lengthCheckZero
        ? reimbursementTxnViewAllData?.transactions.map((data) => data?.txn_id)
        : [];

    UniversalRefreshToast("Rejecting transaction");

    let data = null;

    if (id2.length > GlobalConfiguration.lengthCheckZero) {
      data = await dispatch(
        ReimbursementTxnDeniedApproval({ id: id2, AccountIdData }),
      );
    }

    if (
      data?.payload?.errors?.user_unauthorized?.length >
      GlobalConfiguration.lengthCheckZero
    ) {
      const serviceKey = "AReimbursementTxn";

      navigate("/feature_not_assigned", {
        state: { unavailableService: serviceKey },
      });
      return;
    }

    await new Promise((resolve) =>
      setTimeout(resolve, IntervalConfiguration.intervalExtraLarge),
    );

    if (data?.payload?.status === false) {
      const error_msg = data?.payload?.errors?.user_unauthorized
        ? data?.payload?.errors?.user_unauthorized[0]
        : Array.isArray(data?.payload?.errors?.base) &&
            Array.isArray(data?.payload?.errors?.base[0]?.errors)
          ? data.payload.errors.base[0].errors[0]
          : data?.payload?.errors?.base?.[0] || "Unknown error occurred";

      CommonToast({
        text: error_msg,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text_primary)",
          enabledBgColor: "var(--primary_bg)",
        },
      });

      setShowLoader(false);
    } else if (data?.payload?.status === true) {
      setRejectTxnPopup(false);
      setTimeout(() => {
        CommonToast({
          text: "ransaction rejected successfully.",
          icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }, IntervalConfiguration?.intervalSmall);

      if (associateType === "ReimbursementTxn") {
        await dispatch(viewAccountDetail({ id: props?.bene_account_id || id }));
      }

      if (associateType === "rejectAccount") {
        if (
          viewAccountDetailData?.reimbursement_accounts[0]
            ?.pending_reimbursement_requests === "Y"
        ) {
          setRequestRejectAll(true);
          setRejectTxnPopup(false);
          await dispatch(
            viewAccountDetail({ id: props?.bene_account_id || id }),
          );
        } else {
          handleConfirmDecline(id ? id : props?.bene_account_id, AccountIdData);
        }
      }
    } else if (data?.payload === undefined) {
      CommonToast({
        text: "An error occurred while taking action on this account",
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text_primary)",
          enabledBgColor: "var(--primary_bg)",
        },
      });
    }
    setTimeout(() => {
      setRejectTxnPopup(false);
    }, IntervalConfiguration.intervalMedium);
    if (associateType !== "rejectAccount") {
      setDeclineReason("");
      setAssociateType("");
    }
    setShowLoader(false);
  };

  const handleArchiveReject = () => {
    setAchivedOpenPop(false);
    setshowPopupReject(true);
  };

  const getErrorMessage = (res) => {
    const p =
      res?.payload.response.data.ids?.unsuccessful_ids[0].errors ||
      res?.payload;
    const e = res?.error;
    if (typeof p === "string") return p;
    if (p?.message) return p.message;
    if (p?.errors?.base?.[0]) {
      const base = p.errors.base[0];
      return typeof base === "string"
        ? base
        : base?.errors?.[0] || base?.message || "Something went wrong";
    }
    if (e?.message) return e.message;
    return "Something went wrong";
  };

  const handleAssignLabelsProp = async (labelsToAssign) => {
    setLoading(true);

    const toArray = (value) => (Array?.isArray(value) ? value : [value]);
    const res = await dispatch(
      addNewLabel({
        record_ids: toArray(id),
        labels: labelsToAssign,
      }),
    );

    if (addNewLabel.fulfilled.match(res)) {
      toast.dismiss();

      CommonToast({
        text: "Labels assigned successfully.",
        icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }

    if (addNewLabel.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }
    setLoading(false);
    setIndex(0);
    if (addNewLabel?.fulfilled?.match(res)) {
      await fetchData();
      return true;
    } else {
      return false;
    }
  };

  const handleUnassignLabelsProp = async (labelsToUnassign) => {
    setLoading(true);

    const toArray = (value) => (Array.isArray(value) ? value : [value]);

    const res = await dispatch(
      removeNewLabel({
        record_ids: toArray(id),
        labels: labelsToUnassign,
      }),
    );

    if (removeNewLabel.fulfilled.match(res)) {
      toast.dismiss();
      CommonToast({
        text: "Labels unassigned successfully.",
        icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      await fetchData();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }

    if (removeNewLabel.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      await fetchData();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }
    setLoading(false);
    if (removeNewLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const asAcc =
    viewAccountDetailData?.reimbursement_accounts?.[0]?.associate_bank ===
      "Y" ||
    viewAccountDetailData?.reimbursement_accounts?.[0]?.associate_pan === "Y";

  const pendingTxn =
    viewAccountDetailData?.reimbursement_accounts?.[0]
      ?.pending_reimbursement_transactions === "Y";

  const pendingRequestTxn =
    viewAccountDetailData?.reimbursement_accounts?.[0]
      ?.pending_reimbursement_requests === "Y";

  const associatedCategories =
    viewAccountDetailData?.reimbursement_accounts?.[0]?.all_category_assign ===
    "Y";

  const buildAlerts = () => [
    ...(associatedCategories !== undefined
      ? associatedCategories
        ? [
            {
              isLoading: false,

              text: "All categories are assigned to this account",
              icon: "https://q2pay.in/new_assets/common/dashboard/alert.svg",
              onClick: () => {
                toggleCategories();
              },
            },
          ]
        : []
      : [
          {
            isLoading: false,
            text: "Checking category assign",
          },
        ]),
    ...(asAcc !== undefined
      ? asAcc
        ? [
            {
              isLoading: false,
              isDisabled: props?.type === "reimburseacc_details",
              text: "Associated accounts are found",
              icon: "https://q2pay.in/new_assets/common/dashboard/alert.svg",
              onClick: () => {
                if (props?.type === "reimburseacc_details") {
                  actionRestricted();
                } else {
                  openAssociatedAccountsFound();
                }
              },
            },
          ]
        : []
      : [
          {
            isLoading: false,
            text: "Checking associated account",
          },
        ]),

    ...(pendingTxn !== undefined
      ? pendingTxn &&
        viewAccountDetailData?.reimbursement_accounts?.[0]?.approval_status ===
          "pending"
        ? [
            {
              isLoading: false,
              isDisabled: props?.type === "reimburseacc_details",
              text: "Pending transactions found",
              icon: "https://q2pay.in/new_assets/common/dashboard/alert.svg",
              onClick: () => {
                if (props?.type === "reimburseacc_details") {
                  actionRestricted();
                  return;
                } else {
                  const hasAccess =
                    services?.includes("AReimbursementTxn") ||
                    services?.includes("Admin");

                  if (!hasAccess) {
                    navigate("/feature_not_assigned", {
                      state: { unavailableService: "AReimbursementTxn" },
                    });
                    return;
                  }

                  setRejectTxnPopup(true);
                  setAssociateType("ReimbursementTxn");
                  setSearchtype("rejectall");
                }
              },
            },
          ]
        : []
      : [
          {
            isLoading: false,
            text: "Checking pending transactions",
          },
        ]),

    ...(pendingRequestTxn !== undefined
      ? pendingRequestTxn &&
        viewAccountDetailData?.reimbursement_accounts?.[0]?.approval_status ===
          "pending"
        ? [
            {
              isLoading: false,
              isDisabled: props?.type === "reimburseacc_details",
              text: "Pending request found",
              icon: "https://q2pay.in/new_assets/common/dashboard/alert.svg",
              onClick: () => {
                if (props?.type === "reimburseacc_details") {
                  actionRestricted();
                } else {
                  setRequestRejectAll(true);
                  setAssociateType("RejectAllRequestTxn");
                  setSearchtype("rejectall");
                }
              },
            },
          ]
        : []
      : [
          {
            isLoading: false,
            text: "Checking request pending transactions",
          },
        ]),
  ];

  const handleRejectRequestTxn = async () => {
    setShowLoader(true);
    setshowPopupReject(false);
    const AccountIdData = declineReason;
    let id2 = [];

    id2 =
      !reimbursementRequestViewAllLoading &&
      reimbursementRequestViewAllData?.requests?.length >
        GlobalConfiguration.lengthCheckZero
        ? reimbursementRequestViewAllData?.requests?.map(
            (data) => data?.request_id,
          )
        : [];

    UniversalRefreshToast("Rejecting requests");

    let data = null;

    if (id2.length > GlobalConfiguration.lengthCheckZero) {
      data = await dispatch(
        requestTxnReject({ request_ids: id2, AccountIdData }),
      );
    }

    if (
      data?.payload?.errors?.user_unauthorized?.length >
      GlobalConfiguration.lengthCheckZero
    ) {
      const serviceKey = "AReimbursementRequest";

      navigate("/feature_not_assigned", {
        state: { unavailableService: serviceKey },
      });
      return;
    }

    await new Promise((resolve) =>
      setTimeout(resolve, IntervalConfiguration.intervalExtraLarge),
    );

    if (data?.payload?.status === false) {
      const error_msg = data?.payload?.errors?.user_unauthorized
        ? data?.payload?.errors?.user_unauthorized[0]
        : Array.isArray(data?.payload?.errors?.base) &&
            Array.isArray(data?.payload?.errors?.base[0]?.errors)
          ? data.payload.errors.base[0].errors[0]
          : data?.payload?.errors?.base?.[0] || "Unknown error occurred";
      CommonToast({
        text: error_msg,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text_primary)",
          enabledBgColor: "var(--primary_bg)",
        },
      });
      setAchivedOpenPop(false);
      setShowLoader(false);
    } else if (data?.payload?.status === true) {
      setRejectTxnPopup(false);
      setRequestRejectAll(false);
      setTimeout(() => {
        CommonToast({
          text: "Requests rejected successfully.",
          icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }, IntervalConfiguration?.intervalSmall);
      setshowPopupReject(false);
      if (associateType === "rejectAccount") {
        handleConfirmDecline(id ? id : props?.bene_account_id, AccountIdData);
      } else if (ArchiveType === "Requestarchive") {
        archiveAccount(id);
      }
    } else if (data?.payload === undefined) {
      CommonToast({
        text: "An error occurred while taking action on this account",
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text_primary)",
          enabledBgColor: "var(--primary_bg)",
        },
      });
    }
    setTimeout(() => {
      setRejectTxnPopup(false);
    }, IntervalConfiguration.intervalMedium);
    if (associateType !== "rejectAccount") {
      setDeclineReason("");
      setAssociateType("");
    }
    await dispatch(viewAccountDetail({ id: props?.bene_account_id || id }));
    setShowLoader(false);
  };

  const handleArchiveRejectRequest = () => {
    setAchivedOpenPop(false);
    setshowPopupReject(true);
  };

  useLayoutEffect(() => {
    if (index !== prevIndex) {
      const direction =
        index > prevIndex ? "animate-slide-next" : "animate-slide-prev";

      setAnimationClass(direction);
      setPrevIndex(index);
    }
  }, [index]);

  // useEffect

  useEffect(() => {
    if (props?.type === "reimburseacc_details" && props?.showCategory) {
      setIndex(GlobalConfiguration.lengthCheckOne);
    }
  }, [props]);

  useEffect(() => {
    if (
      viewAccountDetailData &&
      viewAccountDetailData.reimbursement_accounts &&
      viewAccountDetailData.reimbursement_accounts.length >
        GlobalConfiguration.lengthCheckZero
    ) {
      const { pan_legal_name, contact_no, email_id } =
        viewAccountDetailData.reimbursement_accounts[0];
      setPreviousContactDetails({
        legalName: pan_legal_name,
        contact: contact_no,
        email: email_id,
        category: category || null,
      });
    }
  }, [viewAccountDetailData]);

  useEffect(() => {
    if (
      viewAccountDetailData &&
      viewAccountDetailData.reimbursement_accounts &&
      viewAccountDetailData.reimbursement_accounts.length >
        GlobalConfiguration.lengthCheckZero
    ) {
      const { category } = viewAccountDetailData.reimbursement_accounts[0];
      setCategory(category);
    }
  }, [viewAccountDetailData]);

  useEffect(() => {
    if (
      viewAccountDetailData &&
      viewAccountDetailData.reimbursement_accounts &&
      viewAccountDetailData.reimbursement_accounts.length >
        GlobalConfiguration.lengthCheckZero
    ) {
      const { bank_acc_no, name, ifsc_code } =
        viewAccountDetailData.reimbursement_accounts[0];
      setBankDetails({
        bankHolderName: name,
        bankAccountNumber: bank_acc_no,
        ifscCode: ifsc_code,
      });
    }
  }, [viewAccountDetailData]);

  useEffect(() => {
    fetchData();
    let availableLabels = sessionStorage?.getItem("AvailableLabels");
    const parsedLabels = JSON?.parse(availableLabels);
    setLabels(parsedLabels);
  }, [props?.bene_account_id, id]);

  useEffect(() => {
    if (viewAccountDetailData) {
      SetViewAccountDetails(viewAccountDetailData?.reimbursement_accounts);
    }
  }, [viewAccountDetailData]);

  useEffect(() => {
    if (
      viewAccountDetailData &&
      viewAccountDetailData.reimbursement_accounts &&
      viewAccountDetailData.reimbursement_accounts.length >
        GlobalConfiguration?.lengthCheckZero
    ) {
      const { bank_name, bank_acc_no, category, ifsc_code, id, pan_no, name } =
        viewAccountDetailData.reimbursement_accounts[0];
      setCurrentAccountDetails({
        bank_name,
        bank_acc_no,
        category,
        ifsc_code,
        id,
        pan: pan_no,
        bank_account_holder_full_name: name,
        name: name,
      });
    }
  }, [viewAccountDetailData]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= ScreenSizeConfiguration?.mobileScreen);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [window.innerWidth]);

  useEffect(() => {
    let accountData = [];
    if (viewAccountDetailData) {
      accountData = viewAccountDetailData?.reimbursement_accounts?.[0].logs;
    }
    if (
      accountData &&
      viewAccountDetailData?.reimbursement_accounts?.[0].archived === "Y"
    ) {
      setNameArchive(
        [...accountData]
          .filter((fil) => {
            return fil.action === "Archived";
          })
          .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))[0]
          .user_full_name,
      );
    }
  }, [ViewAccountDetails]);

  useEffect(() => {
    sessionStorage.removeItem("PAN GST Edit NewValue");
  }, []);

  const switcherTabs = [
    {
      label: "Details",
      key: "Details",
    },
    {
      label: "Categories",
      key: "Categories",
    },
    {
      label: "Labels",
      key: "Labels",
    },
    {
      label: "Recipients",
      key: "Recipients",
    },
  ];

  useEffect(() => {
    setIndex(GlobalConfiguration.lengthCheckZero);
  }, [id]);

  return (
    <>
      {isEditModalOpen && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <EditCommonPopup
            btnOneHandleFunction={handleModalClose}
            headerTitle="Select the option you would like to edit:"
            alertText="Make sure you understand the impact before archiving."
            alertBackground="emphasis"
            chipsArray={chipsArray}
            btnOneText="Cancel"
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneHoverOption="white"
            btnOneOutLineColor="var(--text-primary)"
            btnTwoText="Edit"
            btnTwoHandleFunction={handleApply}
            btnTwoIsDisabled={
              selectedChipIndex === null ||
              selectedChipIndex === GlobalConfiguration.lengthCheckZero
            }
            btnTwoDisabledTextColor="var(--text-primary)"
            btnTwoEnabledBgColor="var(--text-primary)"
            btnTwoEnabledTextColor="var(--primary-bg)"
            // btnTwoIsLoaderNeeded={handleLoading}
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoHoverOption="black"
          />
        </div>
      )}
      {showAdditionalSection && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <AdditionalRecipient
            finalRecipients={finalRecipients}
            setShowAdditionalSection={setShowAdditionalSection}
            accountID={id}
            showAdditionalRecipient={showAdditionalRecipient}
            setShowAdditionalRecipient={setShowAdditionalRecipient}
            handleConfirm={handleConfirm}
            recipients={recipients}
            setRecipients={setRecipients}
            buttonDisabled={recipientButtonDisabled}
            setButtonDisabled={setRecipientButtonDisabled}
            additionalChip={additionalChip}
            setAdditionalChip={setAdditionalChip}
          />
        </div>
      )}

      {showPopupReject && (
        <div className="fixed top-top-base left-left-base w-full h-full  flex items-center justify-center z-max-zindex ">
          <div className="top-top-base left-left-base absolute w-full h-full bg-PopUp-BackDrop opacity-dark-opacity" />
          <SmallPopupWithInput
            headerTitle="Rejected reason"
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            secondHeaderTitle="Please state the reason for rejecting the account."
            secondHeaderFontWeight="normal"
            secondHeaderFontColor="text-secondary"
            secondHeaderTextSize="font-xs"
            // noteText="The reason must consist of at least 10 characters."
            noteColor="text-secondary"
            inputPlaceholder={TEXT.REASON_10_150_CHAR}
            inputVariant={
              declineReason &&
              declineReason.length > GlobalConfiguration.accountnormalLength
                ? "verified"
                : declineReason &&
                    declineReason.length <
                      GlobalConfiguration.owneraccountnormalLength
                  ? "typing"
                  : "default"
            }
            inputIsDisabled={showLoader ? true : false}
            btnOneIsDisabled={showLoader ? true : false}
            inputBgColor="var(--primary-bg)"
            inputFgColor="var(--text-secondary)"
            inputOnInput={(e) => {
              if (!showLoader) {
                handleInputChange(e);
              }
            }}
            inputValue={declineReason}
            inputFontKind="small"
            inputIsFullWidth={true}
            btnOneText="Cancel"
            btnOneHandleFunction={() => {
              if (!showLoader) {
                handleClosePopup();
              }
            }}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneHoverOption="white"
            btnTwoText="Reject"
            btnTwoHandleFunction={() => {
              if (associateType === "ReimbursementTxn") {
                handleRejectReimbursementTxn();
              } else if (ArchiveType === "archive") {
                handleArchiveRejectReimbursementTxn();
              } else if (ArchiveType === "Requestarchive") {
                handleRejectRequestTxn();
              } else if (associateType === "RejectAllRequestTxn") {
                handleRejectRequestTxn();
              } else {
                handleRejectTransactionChecker(deniedId, declineReason);
              }
            }}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={
              !declineReason ||
              declineReason.length < GlobalConfiguration.panLength
            }
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoInActiveVariantNeeded={true}
            btnTwoIsLoaderNeeded={showLoader ? true : false}
            btnTwoIsLoading={showLoader ? true : false}
            btnTwoHoverOption="black"
          />
        </div>
      )}

      {/* Reject reimbursement transactions associated to the account */}
      {showRejectTnxPopup && (
        <div className="fixed top-top-base left-laft_base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop">
          <LargePopupRedirect
            headerTitle="Associated transactions found"
            headersubtext="The following transactions are linked and need to be rejected before rejecting this account."
            closeiconenabledBgColor="var(--primary-nav)"
            closeiconisLoading={false}
            closeiconhandleFunction={() => {
              setRejectTxnPopup(false);
              setDeclineReason("");
              setShowLoader(false);
              setAchivedOpenPop(false);
            }}
            closeicon={
              "https://q2pay.in/new_assets/common/create_flow/close.svg"
            }
            closeiconhoverOption="white"
            closeiconbtnType={"button"}
            closeiconisDisabled={false}
            closeicondisabledBgColor={""}
            closeiconbuttonRef={null}
            closeicontitle={"Close"}
            btnType={"button"}
            bottomHeaderTextNeed={true}
            bottomHeaderText={
              "To reject the account, please reject the transactions listed above by clicking the “Reject all” button. The transactions will get rejected with the provided rejected reason."
            }
            isbottomSectionneed={true}
            btnText={"Reject all"}
            confirmbtnrequired={true}
            handleFunction={() => {
              if (associateType === "ReimbursementTxn") {
                setshowPopupReject(true);
              } else if (ArchiveType === "archive") {
                handleArchiveReject();
              } else {
                handleRejectReimbursementTxn();
              }
            }}
            isLoaderNeeded={true}
            isLoading={showLoader ? true : false}
            enabledBgColor={"var(--negative-act)"}
            hoverOption={"dark"}
            outLineColor={""}
            enabledTextColor={"var(--text-primary)"}
            fullWidthRequired={false}
            isDisabled={false}
            disabledTextColor={""}
            disabledBgColor={""}
          >
            <ReimbursementTransactionsViewAll
              TxnHistoryid={currentAccountDetails?.id}
              type={"reimburse_txnViewAll_popup"}
              alert={"alertpopup"}
              flow={"reimburse_txnViewAll_popup_reject"}
              closeRejectAllTxn={handleClosePopup}
              seachType={seachType}
              TxnHistoryAccountName={currentAccountDetails?.name}
            />
          </LargePopupRedirect>
        </div>
      )}

      {RequestRejectAll && (
        <>
          <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
            <LargePopupRedirect
              headerTitle="Pending requests found"
              headersubtext="The following requests are linked and need to be rejected before rejecting this account."
              headerFontWeight="semibold"
              headerFontColor="text-primary"
              headertextSize="font-md"
              fullviewisDisabled={false}
              fullviewenabledTextColor="var(--text-primary)"
              fullviewenabledBgColor="var(--primary-nav)"
              fullviewhoverOption="white"
              fullviewicon={ICONS?.REDIRECT}
              fullviewdisabledBgColor="var(--text-disabled)"
              closeiconbtnType="button"
              closeiconhandleFunction={() => {
                setRequestRejectAll(false);
                setDeclineReason("");
              }}
              closeiconisDisabled={false}
              closeiconenabledBgColor="var(--primary-nav)"
              closeicondisabledBgColor="var(--text-disabled)"
              closeiconhoverOption="white"
              closeicon={ICONS?.CLOSE}
              bottomHeaderTextNeed={true}
              bottomHeaderText={
                "To reject the account, please reject the requests listed above by clicking the “Reject all” button. The requests will get rejected with the provided rejected reason."
              }
              isbottomSectionneed={true}
              btnText={"Reject all"}
              confirmbtnrequired={true}
              handleFunction={() => {
                if (associateType === "RejectAllRequestTxn") {
                  setshowPopupReject(true);
                } else if (ArchiveType === "archive") {
                  handleArchiveRejectRequest();
                } else if (
                  ArchiveType === "Requestarchive" &&
                  viewAccountDetailData?.reimbursement_accounts?.[0]
                    ?.pending_reimbursement_transactions === "N"
                ) {
                  handleArchiveRejectRequest();
                } else {
                  handleRejectRequestTxn();
                }
              }}
              enabledBgColor={"var(--negative-act)"}
              hoverOption={"dark"}
              isLoaderNeeded={true}
              isLoading={showLoader ? true : false}
              outLineColor={""}
              enabledTextColor={"var(--text-primary)"}
            >
              <ReimbursementRequestViewAll
                type={"requestViewallPopup"}
                flow={"RequestRejectAll"}
                alert={"alertpopup"}
                TxnHistoryid={
                  viewAccountDetailData?.reimbursement_accounts?.[0]?.id
                }
                TxnHistoryAccountName={
                  viewAccountDetailData?.reimbursement_accounts?.[0]?.name
                }
                closeReimburseTxnDetailsModal={() => {
                  setRequestRejectAll(false);
                }}
              />
            </LargePopupRedirect>
          </div>
        </>
      )}

      {showLabelsPopup && (
        <div className="fixed left-left-base w-full top-top-base h-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-max-zindex">
          <CommonAssignLabelPopup
            headerTitle="Assign/unassign labels:"
            headersubtext="Labels will be used to generate statistics for the associated accounts."
            closehandleFunction={handleClose}
            closeisDisabled={false}
            labels={labels}
            setLabels={setLabels}
            LabelAccounts={id}
            isLabelPopupOpen={showLabelsPopup}
            filteredData={viewAccountDetailData?.reimbursement_accounts}
            labelActionDispatchedRef={labelActionDispatchedRef}
            onClose={handleClose}
            loading={loading}
            setLoading={setLoading}
            handleAssignLabels={handleAssignLabelsProp}
            handleUnassignLabels={handleUnassignLabelsProp}
            type="details"
          />
        </div>
      )}

      {HistoryPopup && (
        <>
          <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
            <ReimbursementTxnViewAllPopup
              closeReimburseTxnDetailsModal={() => {
                setHistoryPopup(false);
              }}
              TxnHistoryid={TxnHistoryid}
              TxnHistoryAccountName={TxnHistoryAccountName}
              type={"reimburse_txnViewAll_popup"}
              HistoryPopup={HistoryPopup}
            />
          </div>
        </>
      )}
      {showGstPopup && (
        <LargePopupRedirect
          headerTitle="GST Details"
          isfullViewrequired={true}
          fullviewhandleFunction={() =>
            navigate(`/settings/GST_verification`, {
              state: ViewAccountDetails?.[0]?.gstin_detail,
            })
          }
          closeiconhandleFunction={() => setGstShowPopup(false)}
        >
          <GSTVerification
            gst_number={ViewAccountDetails?.[0]?.gstin_detail}
            popup={true}
          />
        </LargePopupRedirect>
      )}

      {showIfscPopup && (
        <div>
          <LargePopupRedirect
            headerTitle="IFSC Details"
            isfullViewrequired={true}
            smallPopupHeader={"Are you sure you want to leave this page?"}
            fullviewhandleFunction={() =>
              navigate(
                `/settings/IFSC_verification/IFSC_Details/${ViewAccountDetails?.[0]?.ifsc_code}`,
              )
            }
            closeiconhandleFunction={() => setIfscShowPopup(false)}
          >
            <OwnerAccountIFSC
              ifsc_code={ViewAccountDetails?.[0]?.ifsc_code}
              popup={true}
            />
          </LargePopupRedirect>
        </div>
      )}
      {showPanPopup && (
        <div>
          <LargePopupRedirect
            headerTitle="PAN Details"
            isfullViewrequired={true}
            fullviewhandleFunction={() =>
              navigate(`/settings/PAN_verification`, {
                state: ViewAccountDetails?.[0]?.pan_no,
              })
            }
            closeiconhandleFunction={() => setPanShowPopup(false)}
          >
            <PanVerification
              pan_no={ViewAccountDetails?.[0]?.pan_no}
              popup={true}
            />
          </LargePopupRedirect>
        </div>
      )}
      {alertPopUp && (
        <div className="fixed top-top-base left-left-base w-full h-full flex items-center bg-Primary-black justify-center z-z-index-max bg-dark-opacity">
          <FullScreen
            id={props?.bene_account_id}
            setAlertPopUp={setAlertPopUp}
          />
        </div>
      )}
      {userpopup && (
        <div className="fixed top-top-base left-left-base w-screen h-screen z-max-zindex bg-custom-backdrop bg-opacity-dark-opacity">
          <UserDetailsPopup
            User_account_id={ViewAccountDetails?.[0]?.reimbursement_user_id}
            type={"User_details"}
            closeBeneAccountDetailModal={() => {
              setUserpopup(false);
            }}
          />
        </div>
      )}

      <div id="webviewdetailPage h-full">
        <div
          className={`main-div flex flex-col ${props?.type === "reimburseacc_details" ? " h-full" : "h-screen"}  ${
            achivedOpenPop || isEditModalOpen
              ? "overflow-hidden"
              : props?.type === "reimburseacc_details"
                ? " overflow-x-hidden"
                : "overflow-auto overflow-x-hidden"
          }`}
        >
          {loading ? (
            <div
              className={`loader-container m-auto justify-center ${props?.type === "reimburseacc_details" && "h-screen"}  items-center flex`}
            >
              <Loader />
            </div>
          ) : (
            <>
              <div
                className={`  bg-primary-nav mt-margin-base fixed top-top-base left-left-base w-full z-z-index-overlay shadow-box-shadow-bottom ${props?.type === "reimburseacc_details" && "hidden"} Qmd:hidden Qlg:px-padding-base `}
              >
                <div
                  className={` w-full flex ${props?.type === "reimburseacc_details" ? "hidden" : "block"}`}
                >
                  <TopNavComponent
                    isFormattingNotRequired={true}
                    topNavHeader={"Reimbursement"}
                    topNavSubText="Accounts details"
                  />
                </div>{" "}
              </div>
              <div
                className={` h-auto Qmd:bg-primary-nav bg-primary-card ${
                  props?.type === "reimburseacc_details"
                    ? null
                    : "main-alignment"
                }`}
              >
                {openBeneAssociate && (
                  <div className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
                    <LargePopupRedirect
                      headerTitle="Associated accounts"
                      headersubtext="The accounts listed below are linked to the selected reimbursement account."
                      closeiconenabledBgColor="var(--primary-nav)"
                      closeiconisLoading={false}
                      closeiconhandleFunction={() => {
                        dispatch(resetToggle());
                        setRemPan("");
                        setRemAccount("");
                        setIFSC("");
                        setActiveType("pan");
                        setOpenBeneAssociate(false);
                      }}
                      closeicon={
                        "https://q2pay.in/new_assets/common/create_flow/close.svg"
                      }
                      closeiconhoverOption="white"
                      closeiconbtnType={"button"}
                      closeiconisDisabled={false}
                      closeicondisabledBgColor={""}
                      closeiconbuttonRef={null}
                      closeicontitle={"Close"}
                      btnType={"button"}
                      confirmbtnrequired={true}
                      enabledBgColor={"var(--negative-act)"}
                      hoverOption={"dark"}
                      outLineColor={""}
                      enabledTextColor={"var(--text-primary)"}
                      fullWidthRequired={false}
                      isDisabled={false}
                      disabledTextColor={""}
                      disabledBgColor={""}
                      ispanbankRequired={true}
                      togglepan={() => {
                        setActiveType("pan");
                        setRemPan(currentAccountDetails?.pan);
                        setRemAccount("");
                        setIFSC("");
                        setSearchPanText(currentAccountDetails?.pan);
                      }}
                      toggleBank={() => {
                        setActiveType("bank");
                        setRemPan("");
                        setRemAccount(currentAccountDetails?.bank_acc_no);
                        setIFSC(currentAccountDetails?.ifsc_code);
                        setSearchPanText(currentAccountDetails?.pan);
                      }}
                    >
                      <ReimbursementAccountViewAll
                        id={
                          viewAccountDetailData?.reimbursement_accounts[0]?.id
                        }
                        type={"ReimbursementAcc"}
                        remPan={remPan}
                        remAccount={remAccount}
                        remIFSC={remIFSC}
                        activeType={activeType}
                        searchPanText={searchPanText}
                        currentAccountDetails={currentAccountDetails}
                        setOpenBeneAssociate={setOpenBeneAssociate}
                        openBeneAssociate={openBeneAssociate}
                      />
                    </LargePopupRedirect>
                  </div>
                )}
                {unachivedOpenPop && (
                  <div
                    onClick={() => setUnachivedOpenPop(false)}
                    className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity"
                  >
                    <SmallPopup
                      headerTitle={
                        "Are you sure you want to unarchive this account?"
                      }
                      subtext="Unarchiving this account will make it active again and set its status to pending."
                      btnOneText="Cancel"
                      btnOneBtnType="button"
                      btnOneEnabledBgColor="transparent"
                      btnOneHandleFunction={handleCloseModal}
                      btnOneOutLineColor="var(--text-primary)"
                      btnOneEnabledTextColor="var(--text-primary)"
                      btnOneIsDisabled={false}
                      btnOneHoverOption="white"
                      btnTwoText="Unarchive"
                      btnTwoBtnType="button"
                      btnTwoHandleFunction={handleUnArchiveButton}
                      btnTwoEnabledBgColor="var(--positive-act)"
                      btnTwoEnabledTextColor="var(--text-primary)"
                      btnTwoIsDisabled={false}
                      btnTwoHoverOption="black"
                    />
                  </div>
                )}
                {achivedOpenPop && (
                  <div
                    onClick={() => setAchivedOpenPop(false)}
                    className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity"
                  >
                    <div>
                      <SmallPopup
                        headerTitle={
                          "Are you sure you want to archive this account?"
                        }
                        headerFontWeight="semibold"
                        headerFontColor="text-primary"
                        textSize="font-md"
                        subtext="Archiving this account will make it inactive and cannot be used unless unarchived."
                        btnOneText="Cancel"
                        btnOneBtnType="button"
                        btnOneEnabledBgColor="transparent"
                        btnOneHandleFunction={handleCloseModal}
                        btnOneOutLineColor="var(--text-primary)"
                        btnOneEnabledTextColor="var(--text-primary)"
                        btnOneIsDisabled={false}
                        btnOneHoverOption="black"
                        btnTwoIsLoaderNeeded={true}
                        btnTwoIsLoading={archiveloader ? true : false}
                        btnTwoText="Archive"
                        btnTwoBtnType="button"
                        btnTwoHandleFunction={() => {
                          setArchiveLoader(true);
                          setArchiveType("archive");
                          handleArchiveButton(
                            viewAccountDetailData?.reimbursement_accounts?.[0]
                              ?.id,
                          );
                        }}
                        btnTwoEnabledBgColor="var(--negative-act)"
                        btnTwoEnabledTextColor="var(--text-primary)"
                        btnTwoIsDisabled={false}
                        btnTwoHoverOption="black"
                      />
                    </div>
                  </div>
                )}

                <div
                  className={`w-full max-w-screen-Qlg m-auto Qmd:bg-primary-nav bg-primary-card ${props?.type === "reimburseacc_details" ? "" : "Qlg:mt-margin-sm"} `}
                  id="container"
                >
                  <div className="flex w-full bg-primary-nav  m-auto h-height-sm  Qlg:px-padding-base px-padding-base">
                    <div
                      className={`bene-account-primary-details ${props?.type === "reimburseacc_details" ? "" : "pt-padding-xs"}   ${
                        props?.type === "reimburseacc_details"
                          ? ""
                          : "mt-margin-base Qmd:mt-margin-lg"
                      }`}
                    >
                      {viewAccountDetailData?.reimbursement_accounts.map(
                        (account) => (
                          <div
                            key={account.id}
                            className="flex border-b border-solid border-primary-bg justify-between mx-margin-md Qmd:mx-margin-base"
                          >
                            <div className="flex flex-col Qmd:flex-row w-full pt-padding-xs  ">
                              <div className="py-padding-md w-full Qmd:w-right-half border-b Qmd:border-b-border-base border-solid border-primary-bg">
                                <div className="flex flex-col Qmd:border-r border-solid border-primary-bg Qlg:pl-padding-sm">
                                  <TitleSubtitlePair
                                    title={accountNameStandardised(
                                      account.name.trim(),
                                    )}
                                    titleColor="text-primary "
                                    subtitle={
                                      account?.name?.trim() ===
                                      account?.pan_legal_name?.trim()
                                        ? "Account name - Using legal name"
                                        : "Account name"
                                    }
                                    alignRight={false}
                                    hoverOption="white"
                                    isBold={false}
                                    variant="md"
                                  />
                                </div>
                              </div>

                              {ViewAccountDetails?.map((account) => (
                                <div
                                  key={account?.id}
                                  className="w-full Qmd:w-right-half py-padding-md"
                                >
                                  <div className="flex flex-col items-start  Qmd:pl-padding-md">
                                    <TitleSubtitlePair
                                      title={
                                        account?.approval_status === "error"
                                          ? "Pending"
                                          : account?.approval_status
                                              ?.toLowerCase()
                                              ?.split(" ")
                                              ?.map(
                                                (word) =>
                                                  word
                                                    .charAt(
                                                      GlobalConfiguration?.lengthCheckZero,
                                                    )
                                                    .toUpperCase() +
                                                  word.slice(
                                                    GlobalConfiguration?.lengthCheckOne,
                                                  ),
                                              )
                                              ?.join(" ")
                                      }
                                      titleColor={`${
                                        account?.approval_status ===
                                          "pending" ||
                                        account?.approval_status === "error"
                                          ? "pending"
                                          : account?.approval_status ===
                                              "approved"
                                            ? "awaiting"
                                            : account?.approval_status ===
                                                "rejected"
                                              ? "failed"
                                              : account?.approval_status ===
                                                  "blocked"
                                                ? "failed"
                                                : account?.approval_status ===
                                                    "archived"
                                                  ? "abandoned"
                                                  : ""
                                      }`}
                                      subtitle="Account status"
                                      alignRight={false}
                                      hoverOption="white"
                                      isBold={true}
                                      variant="md"
                                    />
                                  </div>
                                </div>
                              ))}
                            </div>
                            <div
                              className={`associated-account-transaction-history-block Qmd:flex flex-row ${props?.type === "reimburseacc_details" && " opacity-light-opacity"} bg-primary-nav-act hidden`}
                            >
                              <TopNavSmallButton
                                btnText={
                                  <>
                                    Linked <br /> user
                                  </>
                                }
                                handleFunction={() => {
                                  if (props?.type === "reimburseacc_details") {
                                    actionRestricted();
                                  } else {
                                    if (services?.includes("VSpecificEmp")) {
                                      if (
                                        viewAccountDetailData
                                          ?.reimbursement_accounts?.[0]
                                          ?.reimbursement_user_full_name
                                      ) {
                                        setUserpopup(true);
                                      } else {
                                        CommonToast({
                                          text: "No user is linked to this account.",
                                          icon: "https://q2pay.in/new_assets/common/settings/error_with_white_circle.svg",
                                          variant: "var(--error)",
                                          btnProps: {
                                            isDisabled: false,
                                            enabledTextColor:
                                              "var(--text-primary)",
                                            enabledBgColor: "var(--error)",
                                          },
                                        });
                                      }
                                    } else {
                                      navigate("/feature_not_assigned", {
                                        state: {
                                          unavailableService: "VSpecificEmp",
                                        },
                                      });
                                    }
                                  }
                                }}
                                icon="https://q2pay.in/new_assets/common/detail_page/linked_white_circle.svg"
                                enabledBgColor={"var(--primary-nav-act)"}
                                enabledTextColor={"var(--text-primary)"}
                                disabledBgColor={"var(--primary-nav-act)"}
                                disabledTextColor={"var(--text-primary)"}
                                isDisabled={
                                  props?.type === "reimburseacc_details"
                                    ? true
                                    : services?.find(
                                          (service) =>
                                            service === "VSpecificEmp" ||
                                            service === "Admin",
                                        ) !== undefined &&
                                        account?.reimbursement_user_full_name
                                      ? false
                                      : account?.reimbursement_user_full_name
                                        ? false
                                        : true
                                }
                                hoverOption="white"
                              />
                              <div className="py-padding-button-l flex ">
                                <div className="flex-grow border-r border-solid border-primary-bg"></div>
                              </div>
                              <TopNavSmallButton
                                btnText={
                                  <>
                                    Associated <br></br> accounts
                                  </>
                                }
                                handleFunction={() => {
                                  if (props?.type === "reimburseacc_details") {
                                    actionRestricted();
                                    return;
                                  }
                                  openAssociatedAccountsFound();
                                }}
                                icon="https://q2pay.in/new_assets/common/detail_page/associated_accounts_found.svg"
                                enabledBgColor={"var(--primary-nav-act)"}
                                enabledTextColor={"var(--text-primary)"}
                                disabledBgColor={"var(--primary-nav-act)"}
                                disabledTextColor={"var(--text-primary)"}
                                isDisabled={
                                  props?.type === "reimburseacc_details"
                                    ? true
                                    : false
                                }
                                hoverOption="white"
                              />

                              <div className="py-padding-button-l flex">
                                <div className="flex-grow border-r border-solid border-primary-bg"></div>
                              </div>

                              <TopNavSmallButton
                                btnText={
                                  <>
                                    Transaction <br /> history
                                  </>
                                }
                                handleFunction={() => {
                                  if (props?.type === "reimburseacc_details") {
                                    actionRestricted();
                                    return;
                                  }
                                  setHistoryPopup(true);
                                  setTxnHistoryAccountName(
                                    account?.bank_account_holder_full_name,
                                  );
                                  setTxnHistoryid(account?.id);
                                }}
                                icon="https://q2pay.in/new_assets/common/detail_page/transaction_history.svg"
                                enabledBgColor={"var(--primary-nav-act)"}
                                enabledTextColor={"var(--text-primary)"}
                                disabledBgColor={"var(--primary-nav-act)"}
                                disabledTextColor={"var(--text-primary)"}
                                hoverOption="white"
                                isDisabled={
                                  props?.type === "reimburseacc_details"
                                    ? true
                                    : false
                                }
                              />
                            </div>
                          </div>
                        ),
                      )}
                      {viewAccountDetailData?.reimbursement_accounts.map(
                        (account) => (
                          <div
                            key={account.id}
                            className="bene-account-holder-details flex border-b border-solid border-primary-bg justify-between Qmd:mx-margin-base mx-margin-md"
                          >
                            <div className="flex flex-col Qmd:flex-row w-full ">
                              <div className=" flex w-full  Qsmd:w-width-md justify-between Qmd:border-b-border-base border-b border-solid border-primary-bg">
                                <div className="py-padding-md Qlg:pl-padding-sm flex flex-col w-full Qmd:w-right-half ">
                                  <TitleSubtitlePair
                                    title={formatAccountNumber(
                                      account?.bank_acc_no,
                                    )}
                                    titleColor="text-primary"
                                    subtitle="  Account number"
                                    alignRight={false}
                                    hoverOption="white"
                                    isBold={false}
                                    variant="md"
                                  />
                                </div>
                                <div className="h-[max-content] flex justify-center items-center bg-text-primary rounded-border-radius-md mb-margin-md mt-margin-lg Qmd:mr-margin-md">
                                  <CommonBankLogo
                                    ifsc={account?.ifsc_code}
                                    variant="big"
                                    type="pill"
                                  />
                                </div>
                              </div>
                              <div className="py-padding-md w-full Qmd:w-right-half">
                                <div className="flex flex-col items-start  Qmd:px-padding-md Qmd:border-l border-l-border-base border-solid border-primary-bg">
                                  <TitleSubtitlePair
                                    title={
                                      account.bank_account_holder_full_name
                                    }
                                    titleColor="text-primary"
                                    subtitle=" Bank account holder name"
                                    alignRight={false}
                                    hoverOption="white"
                                    isBold={false}
                                    variant="md"
                                  />
                                </div>
                              </div>
                            </div>
                            <div
                              className=" hidden Qsmd:block"
                              style={{
                                visibility: "hidden",
                                backgroundColor: "var(--primary-nav)",
                              }}
                            >
                              <TopNavSmallButton
                                btnText={
                                  <>
                                    {" "}
                                    Edit <br /> account
                                  </>
                                }
                                handleFunction={() => {
                                  CommonToast({
                                    text: "Feature coming soon",
                                    icon: "https://q2pay.in/new_assets/common/detail_page/info.svg",
                                    variant: "var(--coming-soon)",
                                    buttonNeeded: false,
                                  });
                                }}
                                icon={
                                  "https://q2pay.in/new_assets/common/detail_page/edit_with_white_circle.svg"
                                }
                                enabledBgColor={"var(--primary-nav-act)"}
                                enabledTextColor={"var(--text-primary"}
                                hoverOption="white"
                                isDisabled={
                                  props?.type === "reimburseacc_details" ||
                                  viewAccountDetailData
                                    ?.reimbursement_accounts[0]
                                    .approval_status === "archived" ||
                                  viewAccountDetailData
                                    ?.reimbursement_accounts[0]
                                    .approval_status === "blocked"
                                }
                              />
                            </div>
                            <div
                              className={`settings Qmd:flex flex-row hidden justify-end ${props?.type === "reimburseacc_details" && "opacity-light-opacity"} bg-primary-nav-act`}
                            >
                              <TopNavSmallButton
                                btnText={
                                  <>
                                    {" "}
                                    Edit <br /> account
                                  </>
                                }
                                handleFunction={() => {
                                  if (
                                    viewAccountDetailData
                                      ?.reimbursement_accounts?.[0]
                                      .approval_status !== "archived" &&
                                    viewAccountDetailData
                                      ?.reimbursement_accounts?.[0]
                                      .approval_status !== "blocked"
                                  ) {
                                    if (
                                      props?.type === "reimburseacc_details"
                                    ) {
                                      actionRestricted();
                                    } else {
                                      if (
                                        services?.find(
                                          (service) =>
                                            service === "RUAccount" ||
                                            service === "Admin",
                                        ) !== undefined
                                      ) {
                                        handleModalOpen(id);
                                      } else {
                                        navigate("/feature_not_assigned", {
                                          state: {
                                            unavailableService: "RUAccount",
                                          },
                                        });
                                      }
                                    }
                                  }
                                }}
                                icon={
                                  "https://q2pay.in/new_assets/common/detail_page/edit_with_white_circle.svg"
                                }
                                enabledBgColor={"var(--primary-nav-act)"}
                                enabledTextColor={"var(--text-primary"}
                                hoverOption="white"
                                isDisabled={
                                  props?.type === "reimburseacc_details"
                                    ? true
                                    : viewAccountDetailData
                                          ?.reimbursement_accounts[0]
                                          .approval_status === "archived" ||
                                        viewAccountDetailData
                                          ?.reimbursement_accounts?.[0]
                                          .approval_status === "blocked"
                                      ? true
                                      : services?.find(
                                            (service) =>
                                              service === "RUAccount" ||
                                              (service === "Admin" &&
                                                props?.servicesType !==
                                                  "BenAdmin"),
                                          ) !== undefined
                                        ? false
                                        : true
                                }
                              />

                              <div className="py-padding-button-l flex bg-primary-nav-act">
                                <div className="flex-grow border-r border-solid border-primary-bg"></div>
                              </div>

                              <TopNavSmallButton
                                btnText={
                                  viewAccountDetailData
                                    ?.reimbursement_accounts[0]
                                    .approval_status === "archived" ? (
                                    <>
                                      Unarchive <br /> account{" "}
                                    </>
                                  ) : (
                                    <>
                                      Archive <br /> account{" "}
                                    </>
                                  )
                                }
                                handleFunction={() => {
                                  if (
                                    props?.type !== "reimburseacc_details" &&
                                    viewAccountDetailData
                                      ?.reimbursement_accounts[0]
                                      .approval_status !== "blocked"
                                  ) {
                                    if (
                                      services?.find(
                                        (service) =>
                                          service === "RAAccountArchive" ||
                                          service === "Admin",
                                      ) !== undefined
                                    ) {
                                      handleUnarchive();
                                      handleArchive();
                                    } else {
                                      navigate("/feature_not_assigned", {
                                        state: {
                                          unavailableService:
                                            "RAAccountArchive",
                                        },
                                      });
                                    }
                                  } else {
                                    actionRestricted();
                                  }
                                }}
                                icon={
                                  viewAccountDetailData
                                    ?.reimbursement_accounts[0]
                                    .approval_status === "archived"
                                    ? "https://q2pay.in/new_assets/common/detail_page/unarchive.svg"
                                    : "https://q2pay.in/new_assets/common/detail_page/archive.svg"
                                }
                                enabledBgColor={"var(--primary-nav-act)"}
                                enabledTextColor={"var(--text-primary"}
                                hoverOption="white"
                                isDisabled={
                                  props?.type === "reimburseacc_details"
                                    ? true
                                    : viewAccountDetailData
                                          ?.reimbursement_accounts[0]
                                          .approval_status === "blocked"
                                      ? true
                                      : false
                                }
                              />
                            </div>
                          </div>
                        ),
                      )}
                      {viewAccountDetailData?.reimbursement_accounts.map(
                        (account) => (
                          <div
                            key={account.id}
                            className="bene-account-holder-details flex justify-between, flex-col Qmd:flex-row overflow-x-hidden "
                          >
                            <div className="flex  Qmd:flex-row  w-full ">
                              <div
                                className={`flex justify-between w-full ${account?.approval_status === "archived" || account?.approval_status === "blocked" || account?.approval_status === "rejected" ? " lg:w-width-lg" : "lg:w-right-half "}  Qlg:my-margin-sm mx-margin-sm Qmd:mx-margin-base py-padding-sm Qlg:py-padding-base `}
                              >
                                <div
                                  className={` ${props?.type === "reimburseacc_details" && "opacity-light-opacity"} `}
                                >
                                  <TitleSubtitlePair
                                    title={account?.ifsc_code}
                                    titleColor="text-primary "
                                    isDisabled={
                                      props?.type === "reimburseacc_details"
                                        ? true
                                        : false
                                    }
                                    subtitle="IFSC code"
                                    alignRight={false}
                                    hoverOption="white"
                                    isBold={false}
                                    variant="md"
                                    showArrow="true"
                                    onClick={() => {
                                      if (
                                        services?.find(
                                          (service) =>
                                            service === "VIFSC" ||
                                            service === "Admin",
                                        ) !== undefined &&
                                        account?.ifsc_code
                                      ) {
                                        if (
                                          props?.type === "reimburseacc_details"
                                        ) {
                                          actionRestricted();
                                        } else {
                                          setIfscShowPopup(true);
                                        }
                                      } else {
                                        navigate("/feature_not_assigned", {
                                          state: {
                                            unavailableService: "VIFSC",
                                          },
                                        });
                                      }
                                    }}
                                  />
                                </div>
                              </div>
                              <div
                                className={`${account?.approval_status === "archived" || account?.approval_status === "blocked" || account?.approval_status === "rejected" ? "  lg:w-width-lg" : ""}`}
                              ></div>
                              <div
                                className={`py-padding-md  lg:w-width-md ${account?.approval_status === "archived" || account?.approval_status === "blocked" || account?.approval_status === "rejected" ? "  lg:w-width-md" : " Qsmd:w-width-sm-1-3"} flex justify-between ${
                                  ViewAccountDetails[0]?.approval_status ===
                                    "rejected" ||
                                  (ViewAccountDetails[0]?.approval_status ===
                                    "pending" &&
                                    ViewAccountDetails[0]?.error_msg?.length >
                                      GlobalConfiguration.lengthCheckZero)
                                    ? "denied-ifsc-div"
                                    : ""
                                }`}
                              >
                                <div
                                  className={`account-ifsc-div-main  flex flex-row pl-padding-sm Qmd:pl-padding-md w-full `}
                                ></div>
                              </div>
                            </div>
                            <div
                              className={`flex justify-end w-full Qmd:w-width-sm-1-3  Qmd:h-auto  ${
                                (ViewAccountDetails[0]?.approval_status ===
                                  "blocked" ||
                                  ViewAccountDetails[0]?.approval_status ===
                                    "archived" ||
                                  ViewAccountDetails[0]?.approval_status ===
                                    "rejected") &&
                                "hidden"
                              }`}
                            >
                              <div
                                className={`${
                                  (ViewAccountDetails[0]?.approval_status ===
                                    "rejected" &&
                                    ViewAccountDetails[0]?.error_msg?.length >
                                      GlobalConfiguration.lengthCheckZero) ||
                                  (ViewAccountDetails[0]?.approval_status ===
                                    "pending" &&
                                    ViewAccountDetails[0]?.error_msg?.length >
                                      GlobalConfiguration.lengthCheckZero)
                                    ? "w-full"
                                    : " w-full "
                                }`}
                              >
                                <div
                                  className={` pay-bene w-full flex justify-end`}
                                >
                                  {ViewAccountDetails?.map((account) => (
                                    <>
                                      {account?.approval_status ===
                                      "approved" ? (
                                        <>
                                          <TopNavLargeButton
                                            hoverOption={"black"}
                                            btnText={
                                              <>
                                                Reimburse the <br /> account
                                              </>
                                            }
                                            btnType={"button"}
                                            handleFunction={() => {
                                              if (
                                                !viewAccountDetailData
                                                  ?.reimbursement_accounts?.[0]
                                                  ?.category?.length
                                              ) {
                                                CommonToast({
                                                  text: "Category can't be blank",
                                                  icon: ICONS?.ERROR_WHITE_CIRCLE,
                                                  variant: "var(--error)",
                                                  btnProps: {
                                                    isDisabled: false,
                                                    enabledTextColor:
                                                      "var(--text_primary)",
                                                    enabledBgColor:
                                                      "var(--primary_bg)",
                                                  },
                                                });
                                              } else {
                                                navigate(
                                                  "/reimbursement_transaction_dashboard/create_reimbursement_transactions",
                                                  {
                                                    state: {
                                                      ...currentAccountDetails,
                                                      type: "payReimbursementdetails",
                                                    },
                                                  },
                                                );
                                              }
                                            }}
                                            icon={
                                              "https://q2pay.in/new_assets/common/detail_page/reimbursement_detail.svg"
                                            }
                                            enabledBgColor={
                                              "var(--positive-act)"
                                            }
                                            enabledTextColor={
                                              "var(--text-primary)"
                                            }
                                            fullWidthRequired={isMobile}
                                          />
                                        </>
                                      ) : account?.approval_status ===
                                          "rejected" &&
                                        account?.error_msg?.length >
                                          GlobalConfiguration?.lengthCheckZero ? (
                                        <div
                                          key={account.id}
                                          className={`pay-bene-box2 flex justify-end  ${
                                            account?.approval_status ===
                                              "approved" &&
                                            services?.find(
                                              (service) =>
                                                (service ===
                                                  "CReimbursementTxn" &&
                                                  service ===
                                                    "AReimbursementRequest") ||
                                                service === "Admin",
                                            ) !== undefined &&
                                            currentAccountDetails.category
                                              .length >
                                              GlobalConfiguration?.lengthCheckZero
                                              ? "bg-Button-green hover:opacity-dark-opacity"
                                              : account?.approval_status ===
                                                  "approved"
                                                ? "bg-Button-green"
                                                : ""
                                          }`}
                                        >
                                          <div className="flex flex-row gap-x-gap-sm h-full w-full bg-negative-card p-padding-sm">
                                            <div className="flex place-items-center">
                                              <img
                                                src={
                                                  ICONS.ERROR_WITH_WHITE_OUTLINED_CIRCLE
                                                }
                                                alt="Not  found"
                                              />
                                            </div>
                                            <div className="flex flex-col justify-center gap-y-gap-xs w-width-lg">
                                              <span className="font-semibold font-sans text-xs text-text-primary">
                                                Failed to take action
                                              </span>

                                              <span className="font-sans text-font_xxs text-text-secondary text-ellipsis overflow-hidden w-full block">
                                                {account?.error_msg}
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      ) : account?.approval_status ===
                                          "pending" &&
                                        account?.error_msg?.length >
                                          GlobalConfiguration?.lengthCheckZero ? (
                                        <div
                                          key={account?.id}
                                          className={`pay-bene-box2 w-full  lg:flex  lg:justify-end ${
                                            account?.approval_status ===
                                              "approved" &&
                                            services?.find(
                                              (service) =>
                                                (service ===
                                                  "CReimbursementTxn" &&
                                                  service ===
                                                    "AReimbursementRequest") ||
                                                service === "Admin",
                                            ) !== undefined &&
                                            currentAccountDetails.category
                                              .length >
                                              GlobalConfiguration?.lengthCheckZero
                                              ? "bg-Button-green hover:opacity-dark-opacity"
                                              : account?.approval_status ===
                                                  "approved"
                                                ? "bg-Button-green"
                                                : ""
                                          }`}
                                        >
                                          <div className="flex flex-row h-full w-full bg-negative-card p-padding-sm gap-gap-sm">
                                            <div className="flex place-items-center ">
                                              <img
                                                src={
                                                  ICONS.ERROR_WITH_WHITE_OUTLINED_CIRCLE
                                                }
                                                alt="Not  found"
                                                className="w-icon-lg h-icon-lg mr-margin-button-m"
                                              />
                                            </div>
                                            <div className="flex flex-col justify-center gap-gap-xs w-5/6 ">
                                              <span className="font-semibold font-sans text-sm text-text-primary">
                                                Failed to take action
                                              </span>

                                              <span className="font-sans text-xs text-text-secondary text-ellipsis overflow-hidden w-full block">
                                                {account?.error_msg}
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      ) : account?.approval_status ===
                                        "error" ? (
                                        <div className="flex flex-row h-full bg-negative-card p-padding-sm">
                                          <div className="flex place-items-center ">
                                            <img
                                              src={
                                                ICONS.ERROR_WITH_WHITE_OUTLINED_CIRCLE
                                              }
                                              alt="Not  found"
                                              className="w-icon-lg h-icon-lg mr-margin-button-m"
                                            />
                                          </div>
                                          <div className="flex flex-col justify-center gap-y-gap-xs w-5/6">
                                            <span className="font-semibold font-sans text-sm text-text-primary">
                                              Failed to take action
                                            </span>
                                            <div>
                                              <p className="line-clamp-3 whitespace-wrap overflow-ellipsis text-font_xs text-text-secondary opacity-base_opacity">
                                                {account?.error_msg
                                                  ? account?.error_msg
                                                  : ReimburseRejectData?.errors
                                                      ?.reimbursement_account?.[0]}
                                                .
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      ) : account?.approval_status ===
                                        "pending" ? (
                                        <div
                                          key={account?.id}
                                          className={`pay-bene-box2 flex justify-end w-full ${
                                            account?.approval_status ===
                                              "approved" &&
                                            services?.find(
                                              (service) =>
                                                service === "CBeneficiaryTxn" ||
                                                service === "Admin",
                                            ) !== undefined &&
                                            currentAccountDetails.category
                                              .length >
                                              GlobalConfiguration?.lengthCheckZero
                                              ? "bg-Button-green hover:opacity-dark-opacity"
                                              : account?.approval_status ===
                                                  "approved"
                                                ? "bg-Button-green"
                                                : ""
                                          }`}
                                        >
                                          <TopNavSmallButton
                                            btnText={
                                              <>
                                                Reject <br /> account
                                              </>
                                            }
                                            handleFunction={() => {
                                              if (
                                                services?.find(
                                                  (service) =>
                                                    service === "RAAccount" ||
                                                    service === "Admin",
                                                ) !== undefined
                                              ) {
                                                setSearchtype("rejectall");
                                                setAssociateType(
                                                  "rejectAccount",
                                                );
                                                handleDeclinedDetials(
                                                  account?.id,
                                                );
                                              } else {
                                                navigate(
                                                  "/feature_not_assigned",
                                                  {
                                                    state: {
                                                      unavailableService:
                                                        "RAAccount",
                                                    },
                                                  },
                                                );
                                              }
                                            }}
                                            icon={
                                              "https://q2pay.in/new_assets/common/approval/reject_icon_red_with_white_circle.svg"
                                            }
                                            isDisabled={
                                              services?.find(
                                                (service) =>
                                                  service === "RAAccount" ||
                                                  service === "Admin",
                                              ) !== undefined
                                                ? false
                                                : true
                                            }
                                            enabledBgColor={
                                              "var(--negative-act)"
                                            }
                                            enabledTextColor={
                                              "var(--text-primary"
                                            }
                                            hoverOption="black"
                                            fullWidthRequired={isMobile}
                                          />

                                          <TopNavSmallButton
                                            btnText={
                                              <>
                                                Approve <br /> account{" "}
                                              </>
                                            }
                                            handleFunction={() => {
                                              if (
                                                services?.find(
                                                  (service) =>
                                                    service === "RAAccount" ||
                                                    service === "Admin",
                                                ) !== undefined
                                              ) {
                                                handleApprovalDetails(
                                                  account?.id,
                                                );
                                              } else {
                                                navigate(
                                                  "/feature_not_assigned",
                                                  {
                                                    state: {
                                                      unavailableService:
                                                        "RAAccount",
                                                    },
                                                  },
                                                );
                                              }
                                            }}
                                            isDisabled={
                                              services?.find(
                                                (service) =>
                                                  service === "RAAccount" ||
                                                  service === "Admin",
                                              ) !== undefined
                                                ? false
                                                : true
                                            }
                                            icon={
                                              "https://q2pay.in/new_assets/common/approval/approve_circle_green_checkmark.svg"
                                            }
                                            enabledBgColor={
                                              "var(--positive-act)"
                                            }
                                            enabledTextColor={
                                              "var(--text-primary"
                                            }
                                            hoverOption="black"
                                            fullWidthRequired={isMobile}
                                          />
                                        </div>
                                      ) : null}
                                    </>
                                  ))}
                                </div>
                              </div>
                            </div>
                          </div>
                        ),
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className="bene_quickaction_containerm block Qmd:hidden">
                <div className="text-text-primary pl-padding-sm py-padding-button-l text-font-sm font-semibold bg-primary-card">
                  Quick Actions
                </div>
                <div>
                  <div>
                    <div
                      className="associated-account-transaction-history-block Qmd:hidden flex flex-row border-b border-solid border-primary-bg"
                      style={{
                        borderTop: "none",
                      }}
                    >
                      <TopNavSmallButton
                        btnText={
                          <>
                            Linked <br /> user{" "}
                          </>
                        }
                        handleFunction={() => {
                          if (props?.type === "reimburseacc_details") {
                            actionRestricted();
                          } else {
                            if (services?.includes("VSpecificEmp")) {
                              if (
                                viewAccountDetailData
                                  ?.reimbursement_accounts?.[0]
                                  ?.reimbursement_user_full_name
                              ) {
                                setUserpopup(true);
                              } else {
                                CommonToast({
                                  text: "No user is linked to this account.",
                                  icon: "https://q2pay.in/new_assets/common/settings/error_with_white_circle.svg",
                                  variant: "var(--error)",
                                  btnProps: {
                                    isDisabled: false,
                                    enabledTextColor: "var(--text-primary)",
                                    enabledBgColor: "var(--error)",
                                  },
                                });
                              }
                            } else {
                              navigate("/feature_not_assigned", {
                                state: {
                                  unavailableService: "VSpecificEmp",
                                },
                              });
                            }
                          }
                        }}
                        icon={
                          "https://q2pay.in/new_assets/common/detail_page/linked_white_circle.svg"
                        }
                        enabledBgColor={"var(--primary-nav-act)"}
                        enabledTextColor={"var(--text-primary"}
                        hoverOption="white"
                        isDisabled={
                          props?.type === "reimburseacc_details"
                            ? true
                            : services?.find(
                                  (service) =>
                                    service === "VSpecificEmp" ||
                                    service === "Admin",
                                ) !== undefined &&
                                viewAccountDetailData
                                  ?.reimbursement_accounts?.[0]
                                  ?.reimbursement_user_full_name
                              ? false
                              : viewAccountDetailData
                                    ?.reimbursement_accounts?.[0]
                                    ?.reimbursement_user_full_name &&
                                  props?.type !== "reimburseacc_details"
                                ? false
                                : true
                        }
                        fullWidthRequired={true}
                      />
                      <div className="flex">
                        <div className="flex-grow border-l border-solid border-primary-bg"></div>
                      </div>
                      <TopNavSmallButton
                        btnText={
                          <>
                            Associated <br /> accounts{" "}
                          </>
                        }
                        handleFunction={() => {
                          if (props?.type === "reimburseacc_details") {
                            actionRestricted();
                            return;
                          }
                          openAssociatedAccountsFound();
                        }}
                        icon={
                          "https://q2pay.in/new_assets/common/detail_page/associated_accounts_found.svg"
                        }
                        enabledBgColor={"var(--primary-nav-act)"}
                        enabledTextColor={"var(--text-primary"}
                        hoverOption="white"
                        isDisabled={props?.type === "reimburseacc_details"}
                        fullWidthRequired={true}
                      />

                      <div className="flex">
                        <div className="flex-grow border-l border-solid border-primary-bg"></div>
                      </div>
                      <TopNavSmallButton
                        btnText={
                          <>
                            {" "}
                            Transaction <br /> history
                          </>
                        }
                        handleFunction={() => {
                          if (props?.type === "reimburseacc_details") {
                            actionRestricted();
                          } else {
                            setHistoryPopup(true);
                            setTxnHistoryAccountName(
                              viewAccountDetailData?.reimbursement_accounts[0]
                                ?.bank_account_holder_full_name,
                            );
                            setTxnHistoryid(
                              viewAccountDetailData?.reimbursement_accounts[0]
                                ?.id,
                            );
                          }
                        }}
                        icon={
                          "https://q2pay.in/new_assets/common/detail_page/transaction_history.svg"
                        }
                        enabledBgColor={"var(--primary-nav-act)"}
                        enabledTextColor={"var(--text-primary"}
                        hoverOption="white"
                        isDisabled={
                          props?.type === "reimburseacc_details" ? true : false
                        }
                        fullWidthRequired={true}
                      />
                    </div>
                    <div className="settingsm flex flex-row">
                      <TopNavSmallButton
                        btnText={
                          <>
                            {" "}
                            Edit <br /> account
                          </>
                        }
                        handleFunction={() => {
                          if (
                            viewAccountDetailData?.reimbursement_accounts?.[0]
                              .approval_status !== "archived" &&
                            viewAccountDetailData?.reimbursement_accounts?.[0]
                              .approval_status !== "blocked"
                          ) {
                            if (props?.type === "reimburseacc_details") {
                              actionRestricted();
                            } else {
                              if (
                                services?.find(
                                  (service) =>
                                    service === "RUAccount" ||
                                    service === "Admin",
                                ) !== undefined
                              ) {
                                handleModalOpen(id);
                              } else {
                                navigate("/feature_not_assigned", {
                                  state: {
                                    unavailableService: "RUAccount",
                                  },
                                });
                              }
                            }
                          }
                        }}
                        icon={
                          "https://q2pay.in/new_assets/common/detail_page/edit_with_white_circle.svg"
                        }
                        enabledBgColor={"var(--primary-nav-act)"}
                        enabledTextColor={"var(--text-primary"}
                        hoverOption="white"
                        isDisabled={
                          props?.type === "reimburseacc_details"
                            ? true
                            : viewAccountDetailData?.reimbursement_accounts[0]
                                  .approval_status === "archived" ||
                                viewAccountDetailData
                                  ?.reimbursement_accounts?.[0]
                                  .approval_status === "blocked"
                              ? true
                              : services?.find(
                                    (service) =>
                                      service === "RUAccount" ||
                                      (service === "Admin" &&
                                        props?.servicesType !== "BenAdmin"),
                                  ) !== undefined
                                ? false
                                : true
                        }
                        fullWidthRequired={true}
                      />

                      <div className="flex">
                        <div className="flex-grow border-l border-solid border-primary-bg"></div>
                      </div>

                      {viewAccountDetailData?.reimbursement_accounts[0]
                        .approval_status === "blocked" ||
                      services?.find(
                        (service) =>
                          service === "RAAccountArchive" || service === "Admin",
                      ) === undefined ? (
                        <>
                          <TopNavSmallButton
                            btnText={label}
                            handleFunction={() => {
                              if (
                                viewAccountDetailData?.reimbursement_accounts[0]
                                  .approval_status !== "blocked"
                              ) {
                                if (
                                  services?.find(
                                    (service) =>
                                      service === "RAAccountArchive" ||
                                      service === "Admin",
                                  ) !== undefined
                                ) {
                                  handleUnarchive();
                                  handleArchive();
                                } else {
                                  navigate("/feature_not_assigned", {
                                    state: {
                                      unavailableService: "RAAccountArchive",
                                    },
                                  });
                                }
                              }
                            }}
                            icon={
                              services?.find(
                                (service) =>
                                  service === "RAAccountArchive" ||
                                  service === "Admin",
                              ) === undefined &&
                              viewAccountDetailData?.reimbursement_accounts[0]
                                .approval_status === "archived"
                                ? "https://q2pay.in/new_assets/common/detail_page/unarchive.svg"
                                : "https://q2pay.in/new_assets/common/detail_page/archive.svg"
                            }
                            enabledBgColor={"var(--primary-nav-act)"}
                            enabledTextColor={"var(--text-primary"}
                            hoverOption="white"
                            isDisabled={
                              props?.type === "reimburseacc_details" ||
                              viewAccountDetailData?.reimbursement_accounts[0]
                                .approval_status === "blocked"
                            }
                            fullWidthRequired={true}
                          />
                        </>
                      ) : (
                        <TopNavSmallButton
                          btnText={
                            viewAccountDetailData?.reimbursement_accounts[0]
                              .approval_status === "archived" ? (
                              <>
                                Unarchive <br /> account{" "}
                              </>
                            ) : (
                              <>
                                Archive <br /> account{" "}
                              </>
                            )
                          }
                          handleFunction={() => {
                            if (
                              props?.type !== "reimburseacc_details" &&
                              viewAccountDetailData?.reimbursement_accounts[0]
                                .approval_status !== "blocked"
                            ) {
                              if (
                                services?.find(
                                  (service) =>
                                    service === "RAAccountArchive" ||
                                    service === "Admin",
                                ) !== undefined
                              ) {
                                handleUnarchive();
                                handleArchive();
                              } else {
                                navigate("/feature_not_assigned", {
                                  state: {
                                    unavailableService: "RAAccountArchive",
                                  },
                                });
                              }
                            } else {
                              actionRestricted();
                            }
                          }}
                          icon={
                            viewAccountDetailData?.reimbursement_accounts[0]
                              .approval_status === "archived"
                              ? "https://q2pay.in/new_assets/common/detail_page/unarchive.svg"
                              : "https://q2pay.in/new_assets/common/detail_page/archive.svg"
                          }
                          enabledBgColor={"var(--primary-nav-act)"}
                          enabledTextColor={"var(--text-primary"}
                          hoverOption="white"
                          isDisabled={props?.type === "reimburseacc_details"}
                          fullWidthRequired={true}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div
                className={`bg-primary-bg flex-grow w-full ${props?.type === "reimburseacc_details" && "pb-padding-lg"}`}
              >
                <div className=" bg-primary-card mb-margin-md Qsmd:mb-margin-base">
                  {" "}
                  <div className="  w-full  lg:w-max-content-width m-auto">
                    {" "}
                    <CommonAlertsStrip alerts={buildAlerts()} />
                  </div>
                </div>

                <div className="h-auto max-w-tab-width-normal bg-primary-bg m-auto pb-padding-md">
                  <div className="detail-category-button w-full ml-margin-md lg:ml-margin-base flex Qmd:pt-padding-md pb-padding-md lg:mx-auto Qmd:mx-margin-md Qlg:mx-margin-base">
                    <div
                      className=" overflow-x-auto"
                      style={{
                        scrollbarWidth: "none",
                      }}
                    >
                      <SwitcherTabs
                        initialActiveTab={switcherTabs[index].key}
                        tabs={switcherTabs}
                        swicherTabBgColor={"var(--primary-card)"}
                        setIndex={setIndex}
                      />
                    </div>
                  </div>
                  {index === GlobalConfiguration?.lengthCheckZero && (
                    <div className={animationClass}>
                      {ViewAccountDetails?.map((account) => {
                        let originItemList = [
                          {
                            content: "+91 " + account?.contact_no ?? "",
                            heading: "Contact number",
                            type: "text",
                          },
                          {
                            content: account?.email_id?.toLowerCase(),
                            heading: "Email ID",
                            type: "text",
                          },
                        ];

                        let AccountItemList = [
                          {
                            content: account?.pan_no,
                            heading: "PAN number",
                            type: "text",

                            onClick: () => {
                              const hasAccess = services?.some(
                                (service) =>
                                  service === "VPAN" || service === "Admin",
                              );

                              if (hasAccess && account?.pan_no) {
                                if (props?.type === "reimburseacc_details") {
                                  actionRestricted();
                                } else {
                                  handlePANDetails(account?.pan_no);
                                }
                              } else {
                                navigate("/feature_not_assigned", {
                                  state: { unavailableService: "VPAN" },
                                });
                              }
                            },

                            isDisabled:
                              props?.type === "reimburseacc_details"
                                ? true
                                : services?.some(
                                      (service) =>
                                        service === "VPAN" ||
                                        service === "Admin",
                                    ) &&
                                    account?.pan_no &&
                                    props?.type !== "reimburseacc_details"
                                  ? false
                                  : true,
                          },

                          {
                            content: account?.pan_legal_name
                              ?.toLowerCase()
                              ?.split(" ")
                              ?.map(
                                (word) =>
                                  word
                                    .charAt(
                                      GlobalConfiguration?.lengthCheckZero,
                                    )
                                    .toUpperCase() +
                                  word.slice(
                                    GlobalConfiguration?.lengthCheckOne,
                                  ),
                              )
                              ?.join(" "),
                            heading: "Legal name",
                            type: "text",
                          },
                          {
                            content: account?.gstin_detail
                              ? account?.gstin_detail
                              : "Not Given",
                            heading: "GST number",
                            type: "text",

                            onClick: account?.gstin_detail
                              ? () => {
                                  if (props?.type === "reimburseacc_details") {
                                    actionRestricted();
                                  } else {
                                    if (!account?.gstin_detail) return;

                                    const hasAccess =
                                      services?.includes("VGSTIN") ||
                                      services?.includes("Admin");
                                    if (hasAccess) {
                                      setGstShowPopup(true);
                                    } else {
                                      navigate("/feature_not_assigned", {
                                        state: { unavailableService: "VGSTIN" },
                                      });
                                    }
                                  }
                                }
                              : undefined,
                          },
                        ];
                        let originTimelineItemList = [
                          {
                            content: account?.created_by_name || "Not given",
                            heading: "Created by",
                            type: "text",
                          },
                          {
                            content: account?.created_on
                              ? formatDateViewAll(
                                  account.created_on,
                                  true,
                                  true,
                                )
                              : "Not given",
                            heading: "Created on",
                            type: "text",
                          },

                          // ✅ APPROVED
                          ...(account?.approval_status === "approved"
                            ? [
                                {
                                  content:
                                    account?.approved_by_name || "Not given",
                                  heading: "Approved by",
                                  type: "text",
                                },
                                {
                                  content: account?.approved_on
                                    ? formatDateViewAll(
                                        account?.approved_on,
                                        true,
                                        true,
                                      )
                                    : "Not given",
                                  heading: "Approved on",
                                  type: "text",
                                },
                              ]
                            : []),

                          // ✅ REJECTED
                          ...(account?.approval_status === "rejected"
                            ? [
                                {
                                  content:
                                    account?.rejected_by_name || "Not given",
                                  heading: "Rejected by",
                                  type: "text",
                                },
                                {
                                  content: account?.rejected_on
                                    ? formatDateViewAll(
                                        account?.rejected_on,
                                        true,
                                        true,
                                      )
                                    : "Not given",
                                  heading: "Rejected on",
                                  type: "text",
                                },
                                {
                                  content:
                                    account?.rejection_reason || "Not given",
                                  heading: "Rejected reason",
                                  type: "text",
                                },
                              ]
                            : []),

                          // ✅ ARCHIVED
                          ...(account?.approval_status === "archived"
                            ? [
                                {
                                  content:
                                    account?.archived === "Y" &&
                                    !account?.archived_by_name
                                      ? nameArchive
                                      : account?.archived_by_name ||
                                        "Not given",
                                  heading: "Archived by",
                                  type: "text",
                                },
                                {
                                  content: account?.archived_on
                                    ? formatDateViewAll(
                                        account?.archived_on,
                                        true,
                                        true,
                                      )
                                    : "Not given",
                                  heading: "Archived on",
                                  type: "text",
                                },
                              ]
                            : []),

                          // ✅ BLOCKED
                          ...(account?.approval_status === "blocked"
                            ? [
                                {
                                  content:
                                    account?.blocked_by_name || "Not given",
                                  heading: "Blocked by",
                                  type: "text",
                                },
                                {
                                  content: account?.blocked_on
                                    ? formatDateViewAll(
                                        account?.blocked_on,
                                        true,
                                        true,
                                      )
                                    : "Not given",
                                  heading: "Blocked on",
                                  type: "text",
                                },
                              ]
                            : []),
                        ];

                        let SupportInformationList = [
                          {
                            content: account?.id,
                            heading: "Account ID",
                            type: "text",
                          },
                        ];

                        return (
                          <div
                            className={`flex flex-col lg:flex-row justify-around gap-gap-md mx-margin-md lg:mx-auto`}
                          >
                            <CommonDetailCard
                              cardTitle="Contact Details"
                              numCols={GlobalConfiguration?.lengthCheckOne}
                              variant="fourth"
                              entries={originItemList}
                            />
                            <CommonDetailCard
                              cardTitle="Account Details"
                              numCols={GlobalConfiguration?.lengthCheckOne}
                              variant="fourth"
                              entries={AccountItemList}
                            />
                            <CommonDetailCard
                              cardTitle="Origin Details"
                              numCols={GlobalConfiguration?.lengthCheckOne}
                              variant="fourth"
                              entries={originTimelineItemList}
                            />
                            <CommonDetailCard
                              cardTitle="Support Information"
                              numCols={GlobalConfiguration?.lengthCheckOne}
                              variant="fourth"
                              entries={SupportInformationList}
                            />
                          </div>
                        );
                      })}
                    </div>
                  )}

                  {index === GlobalConfiguration?.lengthCheckOne && (
                    <div className={animationClass}>
                      <CommonContainerCard header={"Reimbursement Categories"}>
                        {sliceCategory?.filter((item) => item.active === "Y")
                          .length ===
                        viewAccountDetailData?.reimbursement_accounts?.[0]?.category.split(
                          ",",
                        ).length ? (
                          <div className="flex mb-margin-button-l items-center">
                            <img
                              className="w-icon-md h-icon-md mr-margin-sm"
                              src={
                                "https://q2pay.in/new_assets/common/dashboard/alert.svg"
                              }
                              alt="Not  found"
                            />
                            <p className="text-text-primary text-sm font-normal">
                              {TEXT?.ALL_CATEGORIES_ASSIGNED_WARNING}
                            </p>
                          </div>
                        ) : (
                          ""
                        )}
                        <div
                          className={`${
                            viewAccountDetailData?.reimbursement_accounts?.[0]
                              ?.category.length >
                            GlobalConfiguration?.lengthCheckZero
                              ? "assigned-beneficiary-categories-data-div"
                              : ""
                          }`}
                        >
                          {viewAccountDetailData?.reimbursement_accounts.map(
                            (account, index) => (
                              <div key={index}>
                                <div className="flex flex-col Qmd:flex-row Qmd:flex-wrap gap-gap-sm ">
                                  {account?.category
                                    ? account?.category
                                        .split(",")
                                        .map((category, categoryIndex) => (
                                          <div
                                            className="category-card max-w-none Qmd:max-w-detail-page-category-grid flex flex-row items-center"
                                            key={categoryIndex}
                                          >
                                            <div className="bene-category-img flex justify-center items-center opacity-base-opacity">
                                              <img
                                                className="w-icon-lg h-icon-lg cateImage max-w-none"
                                                src={categoryMapper(category)}
                                                alt="bene"
                                              />
                                            </div>
                                            <div className="truncate px-padding-sm text-sm text-text-primary text-left font-sans font-semibold opacity-base-opacity antialiased">
                                              <TickerAnimation
                                                text={category.trim()}
                                              />
                                            </div>
                                          </div>
                                        ))
                                    : null}
                                </div>
                                {!account?.category && (
                                  <p
                                    key={`notFound_${index}`}
                                    className="antialiased text-text-primary text-sm"
                                  >
                                    {TEXT?.ASSIGN_CATEGORY_WARNING}
                                  </p>
                                )}
                              </div>
                            ),
                          )}
                        </div>
                      </CommonContainerCard>
                    </div>
                  )}

                  {index === GlobalConfiguration?.lengthCheckTwo && (
                    <div className={animationClass}>
                      <CommonContainerCard
                        header="Labels"
                        subheader="Labels will be used to generate statistics for the
                                              associated accounts."
                        handleFunction={(e) => {
                          e.stopPropagation();
                          if (
                            !services?.includes("ALabel") &&
                            !services?.includes("RLabel")
                          ) {
                            navigate("/feature_not_assigned", {
                              state: { unavailableService: "ALabel,RLabel" },
                            });
                            return;
                          }
                          if (props?.type === "reimburseacc_details") {
                            actionRestricted();
                            return;
                          }
                          if (!isArchived) {
                            setShowLabelsPopup(true);
                          }
                        }}
                        icon={
                          "https://q2pay.in/new_assets/common/create_flow/edit.svg"
                        }
                        iconIsDisabled={
                          props?.type === "reimburseacc_details"
                            ? true
                            : isArchived
                        }
                      >
                        <div className="flex flex-wrap w-full gap-gap-sm">
                          {Array.isArray(labelDetails) &&
                          labelDetails?.length >
                            GlobalConfiguration.lengthCheckZero ? (
                            <>
                              {labelDetails.map((item, index) => (
                                <div
                                  key={index}
                                  className="px-padding-button-l py-padding-button-m flex rounded-border-radius-md bg-primary-nav max-w-full"
                                >
                                  <div className="text-text-primary text-font-xs inline-block truncate">
                                    {item}
                                  </div>
                                </div>
                              ))}
                            </>
                          ) : (
                            <p className="text-font-sm text-text-primary">
                              No labels assigned.
                            </p>
                          )}
                        </div>
                      </CommonContainerCard>
                    </div>
                  )}

                  {index === GlobalConfiguration?.lengthCheckThree && (
                    <div className={animationClass}>
                      <CommonContainerCard
                        header={TEXT?.ADDITIONAL_RECIPIENTS}
                        subheader={TEXT?.ADDITIONAL_RECIPIENTS_CARD_SUBTEXT}
                        icon={
                          "https://q2pay.in/new_assets/common/create_flow/edit.svg"
                        }
                        handleFunction={(e) => {
                          e.stopPropagation();
                          if (props?.type === "reimburseacc_details") {
                            actionRestricted();
                            return;
                          } else {
                            if (!ensureAll(["RUAccount"]).status) {
                              navigate("/feature_not_assigned", {
                                state: { unavailableService: "RUAccount" },
                              });
                              return;
                            } else if (
                              ViewAccountDetails[0].approval_status ===
                                "archived" ||
                              ViewAccountDetails[0].approval_status ===
                                "blocked"
                            ) {
                              return;
                            } else {
                              setShowAdditionalSection(true);
                              setAdditionalChip(showAdditionalRecipient);
                            }
                          }
                        }}
                        iconIsDisabled={
                          !ensureAll(["RUAccount"]).status
                            ? true
                            : props?.type === "reimburseacc_details" ||
                                ViewAccountDetails[0].approval_status ===
                                  "archived" ||
                                ViewAccountDetails[0].approval_status ===
                                  "blocked"
                              ? true
                              : false
                        }
                      >
                        <div className="flex flex-wrap w-full gap-gap-sm">
                          {Array.isArray(showAdditionalRecipient) &&
                          showAdditionalRecipient?.length >
                            GlobalConfiguration.lengthCheckZero ? (
                            <>
                              {showAdditionalRecipient?.map((item, index) => (
                                <div
                                  key={index}
                                  className="flex flex-row items-center py-padding-button-m px-padding-button-l rounded-border-radius-md relative bg-primary-nav-act max-w-max_width-full"
                                >
                                  <span className="text-text-primary text-font-xs font-normal truncate">
                                    {linkIdentifier(item)}
                                  </span>
                                </div>
                              ))}
                            </>
                          ) : (
                            <span className="text-text-primary text-sm font-normal">
                              {TEXT?.NO_ADDITIONAL_RECIPIENTS_ADDED}
                            </span>
                          )}
                        </div>
                      </CommonContainerCard>
                    </div>
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default ReimbursementAccountDetails;
